import {t} from "../../../../../services/i18n";
import EventTypeStep from "./Steps/EventTypeStep";
import React, {useEffect, useMemo} from "react";
import {useDispatch, useSelector} from "react-redux";
import BasicInformation from "./Steps/BasicInformation";
import * as yup from "yup";
import {addToSelectionsTree, updateCurrStep, updateTempSelection} from "../../../../../redux/stepperSlice";
import {store} from "../../../../../redux/store";
import moment from "moment";
import RepeatConfiguration from "./Steps/RepeatConfiguration";
import {
    daysEnum,
    dbDateFormat,
    dbTimeFormat,
    getPenaltiesTags,
    getSettingsObjectByType,
    hasLimitedCoachViewSchedule,
    hasPermissions,
    isBoxInTrial,
    isStringWithoutEmoji,
    snakeToCamel,
    targetAudienceTasks
} from "../../../../../services/Helpers";
import SessionSettings from "./Steps/SessionSettings";
import SuccessStep from "../../../../common/SuccessStep";
import {flowOptions, getSuccessProps, userFlowsOnly} from "./FlowOptions";
import MultiDayConfiguration from "./Steps/MultiDayConfiguration";
import OneOnOneType from "./Steps/OneOnOneType";
import UserAndMembershipSelection from "./Steps/UserAndMembershipSelection";
import PaymentMethod from "./Steps/PaymentMethod";
import {
    EMAIL,
    APPOINTMENT,
    ENTER_DEBT,
    FREE_PURCHASE,
    messageAudience,
    PUSH,
    SERIES_FUTURE_SESSIONS_EDIT_TYPE,
    SINGLE_SESSION_EDIT_TYPE,
    SMS,
    WHATSAPP,
    SCHEDULE_TYPE,
    USER_TYPE,
    customFieldTypes,
    HOK,
    TRIAL,
    IMMEDIATE,
    seriesPaymentDBTranslate,
    boxSettingsProps,
    USER_FIELDS,
    familyArray,
    USER_TYPE_TC, SCHEDULE_TYPE_TC,
    SITE_TRIAL_SETTINGS, createdStatusId, SITE_LEAD_FORM_SETTINGS, siteFormLeadFieldOptions, messageTemplateScopes,
    SPACES_TYPE, USER_SITE_FIELDS, RELATIVE, FULL, HUGIM_FORM, DEFAULTS, GROUP_FORM, CHARGE_SETTING, siteChargeOptions,
    HUG_FULL_BOOKING, HUG_DAY_BOOKING
} from "../../../../../services/ConstHelper";
import AvailabilitySlotSelection from "./Steps/AvailabilitySlotSelection";
import EditMultiDayConfig from "./Steps/EditMultiDayConfig";
import SpaceConfiguration from "./Steps/SpaceConfiguration";
import MemberDetails from "../../../Forms/Users/MemberDetails";
import StaffMemberRoleSelection from "../../../Forms/Users/StaffMemberRoleSelection";
import { emailRegex, validateAfterEmailSymbol } from "../../../../../services/validationService";
import { MembershipTypes, StaffMemberRoles } from "../../../../../Configs/DatabaseConsts";
import {checkEmailChange, isEmailAvailable} from "../../../../../redux/UserFlowSlice";
import BlockedTime from "./Steps/BlockedTime";
import MessageType from "../../../Forms/Messages/MessageType";
import MessageDetails from "../../../Forms/Messages/MessageDetails";
import PenaltySettings from "../../../Forms/Settings/Penalties/PenaltySettings";
import PenaltyExtraProperties from "../../../Forms/Settings/Penalties/PenaltyExtraProperties";
import PenaltySummary from "../../../Summaries/PenaltySummary";
import TaskDetails from "../../../Forms/Tasks/TaskDetails";
import CustomFieldSelection from "./Steps/CustomFieldSelection";
import CustomFieldSettings from "./Steps/CustomFieldSettings";
import uniqBy from "lodash-es/uniqBy";
import SeriesPaymentOptions from "./Steps/SeriesPaymentOptions";
import HugPaymentsOptions from "./Steps/HugPaymentsOptions";
import Payment from "./Steps/Payment";
import PersonalDetails from "./Steps/PersonalDetails";
import CreateTaskType from "../../../../../../web/src/components/Tasks/TasksSettings/CreateTaskType";
import RequiredFieldsSettings from "../../../Forms/Settings/RequiredFieldsSettings";
import ChooseGroupConnectionUser from "../../../Forms/Groups/ChooseGroupConnectionUser";
import GroupConnectionAddUser from "../../../Forms/Groups/GroupConnectionAddUser";
import SendLink from "../../../Forms/Messages/SendLink";
import SiteTrialSettings from "./Steps/SiteTrialSettings";
import GatesApplySettings from "../../../Forms/Gates/GatesApplySettings";
import GatesActivityHours from "../../../Forms/Gates/GatesActivityHours";
import SiteLeadFormSettings from "../../../Forms/SiteLeadFormSettings";
import EmailAfterPurchase from "../../../Forms/Settings/EmailAfterPurchase";
import AdvancedSeriesSettings from "./Steps/AdvancedSeriesSettings";
import Export from "../../../../../../web/src/components/Finance/Export";
import SendInvoicesReport from "../../../../../../web/src/components/Finance/SendInvoicesReport";
import SendDoctorJournalReport from "../../../../../../web/src/components/Finance/SendDoctorJournalReport";
import NoteTemplate from "./Steps/NoteTemplate";
import Note from "./Steps/Note";
import { conditionalRequiredSchema } from "../../../../../services/stepperService";
import GroupDetails from "./Steps/GroupDetails";
import FlowForm from "./Steps/FlowForm";
import {getTypeByRole} from "../../../../../../web/src/components/Tasks/TasksHelper";
import {closeModal, openModal, STEPPER_CONFIRM_MODAL} from "../../../../../redux/modalManagerSlice";
import {fetchApi} from "../../../../../services/HTTP";
import BuildUniformReport from "../../../../../../web/src/components/Finance/BuildUniformReport";
import UserChargeSetting from "./Steps/UserChargeSetting";
import UserNoteExport from "./Steps/UserNoteExport";
import ChooseHug from "./ChooseHug/ChooseHug";
import BookingType from "./Steps/BookingType";
import { HUG_PARTIAL_BOOKING } from "../../../../../services/ConstHelper";
import {handleEventSpacesRelation} from "../../../../../services/ScheduleService";

export const optionalSteps = {
    EVENT_TYPE: 'EVENT_TYPE',
    APPOINTMENT_OR_AVAILABILITY_STEP: 'APPOINTMENT_OR_AVAILABILITY_STEP',
    BASIC_INFO: 'BASIC_INFO',
    REPEAT_CONFIG: 'REPEAT_CONFIG',
    AVAILABILITY_CONFIG: 'AVAILABILITY_CONFIG',
    MULTI_DAY_CONFIG: 'MULTI_DAY_CONFIG',
    SETTINGS: 'SETTINGS',
    USER_AND_MEMBERSHIP_SELECTION: 'USER_AND_MEMBERSHIP_SELECTION',
    PAYMENT_METHOD_SELECTION: 'PAYMENT_METHOD_SELECTION',
    SUCCESS_PAGE: 'SUCCESS_PAGE',
    EDIT_MULTI_DAY_CONFIG: 'EDIT_MULTI_DAY_CONFIG',
    MEMBER_DETAILS: 'MEMBER_DETAILS',
    STAFF_MEMBER_ROLE_SELECT: 'STAFF_MEMBER_ROLE_SELECT',
    BLOCKED_TIME: 'BLOCKED_TIME',
    MESSAGE_TYPE: 'MESSAGE_TYPE',
    MESSAGE_DETAILS: 'MESSAGE_DETAILS',
    EMAIL_AFTER_PURCHASE: 'EMAIL_AFTER_PURCHASE',
    SPACE_CONFIGURATION: 'SPACE_CONFIGURATION',
    PENALTY_SETTINGS: 'PENALTY_SETTINGS',
    PENALTY_EXTRA_PROPERTIES: 'PENALTY_EXTRA_PROPERTIES',
    PENALTY_SUMMARY: 'PENALTY_SUMMARY',
    TASK_DETAILS: 'TASK_DETAILS',
    TASK_TYPE: 'TASK_TYPE',
    SEND_CONVERT_LINK: 'SEND_CONVERT_LINK',
    CUSTOM_FIELD_TYPE_SELECTION: 'CUSTOM_FIELD_TYPE_SELECTION',
    CUSTOM_FIELD_SETTINGS: 'CUSTOM_FIELD_SETTINGS',
    SERIES_PAYMENT_OPTIONS: 'SERIES_PAYMENT_OPTIONS',
    CHOOSE_HUG_PAYMENT_TYPE: 'CHOOSE_HUG_PAYMENT_TYPE',
    PAYMENT: 'PAYMENT',
    SEND_ONE_TIME_MEMBERSHIP_LINK: 'SEND_ONE_TIME_MEMBERSHIP_LINK',
    PERSONAL_DETAILS: 'PERSONAL_DETAILS',
    LEAD_TO_CONVERT_PERSONAL_DETAILS: 'LEAD_TO_CONVERT_PERSONAL_DETAILS',
    REQUIRED_FIELDS_SETTINGS: 'REQUIRED_FIELDS_SETTINGS',
    CHOOSE_GROUP_CONNECTION_USER: 'CHOOSE_GROUP_CONNECTION_USER',
    GROUP_CONNECTION_ADD_USER: 'GROUP_CONNECTION_ADD_USER',
    SITE_TRIAL_SETTINGS: 'SITE_TRIAL_SETTINGS',
    GATES_APPLY_SETTINGS: 'GATES_APPLY_SETTINGS',
    GATES_ACTIVITY_HOURS: 'GATES_ACTIVITY_HOURS',
    SITE_LEAD_FORM_SETTINGS: 'SITE_LEAD_FORM_SETTINGS',
    ADVANCED_SERIES_SETTINGS: 'ADVANCED_SERIES_SETTINGS',
    EXPORT: 'EXPORT',
    SEND_INVOICES_REPORT: 'SEND_INVOICES_REPORT',
    SEND_DOCTOR_JOURNAL_REPORT: 'SEND_DOCTOR_JOURNAL_REPORT',
    NOTE_TEMPLATE: 'NOTE_TEMPLATE',
    NOTE: 'NOTE',
    GROUP_DETAILS: 'GROUP_DETAILS',
    FLOW_FORM: 'FLOW_FORM',
    SEND_DEBT_LINK: 'SEND_DEBT_LINK',
    BUILD_UNIFORM_REPORT: 'BUILD_UNIFORM_REPORT',
    SEND_CONFIRMATION_LINK: 'SEND_CONFIRMATION_LINK',
    BOOK_TO_HUG_CREATE_LEAD: 'BOOK_TO_HUG_CREATE_LEAD',
    USER_CHARGE_SETTING: 'USER_CHARGE_SETTING',
    USER_NOTE_EXPORT: 'USER_NOTE_EXPORT',
    CHOOSE_HUG_TO_SWAP: 'CHOOSE_HUG_TO_SWAP',
    BOOKING_TYPE: 'BOOKING_TYPE'
}

export const renderStep = {
    EVENT_TYPE: (props) => renderEventTypeSelectionStep(props),
    APPOINTMENT_OR_AVAILABILITY_STEP: (props) => renderAppointmentOrAvailabilityStep(props),
    BASIC_INFO: (props) => renderBasicInfoStep(props),
    REPEAT_CONFIG: (props) => renderRepeatConfigStep(props),
    AVAILABILITY_CONFIG: (props) => renderAvailabilityConfigStep(props),
    MULTI_DAY_CONFIG: (props) => renderMultiDayConfigStep(props),
    SETTINGS: (props) => renderSettingsStep(props),
    USER_AND_MEMBERSHIP_SELECTION: (props) => renderUserAndMembershipSelection(props),
    PAYMENT_METHOD_SELECTION: (props) => renderPaymentMethodSelection(props),
    SUCCESS_PAGE: (props) => renderSuccessStep(props),
    EDIT_MULTI_DAY_CONFIG: (props) => renderEditMultiDayConfig(props),
    MEMBER_DETAILS: (props) => renderMemberDetails(props),
    STAFF_MEMBER_ROLE_SELECT: (props) => renderStaffMemberRoleSelect(props),
    BLOCKED_TIME: (props) => renderBlockedTime(props),
    MESSAGE_TYPE: (props) => renderMessageTypeSelect(props),
    MESSAGE_DETAILS: (props) => renderMessageDetails(props),
    EMAIL_AFTER_PURCHASE: (props) => renderEmailAfterPurchase(props),
    SPACE_CONFIGURATION: (props) => renderSpaceConfigStep(props),
    PENALTY_SETTINGS: (props) => renderPenaltySettingsConfigStep(props),
    PENALTY_EXTRA_PROPERTIES: (props) => renderPenaltyExtraPropertiesConfigStep(props),
    PENALTY_SUMMARY: (props) => renderPenaltySummaryStep(props),
    TASK_TYPE: (props) => renderTaskTypeStep(props),
    TASK_DETAILS: (props) => renderTaskDetailsStep(props),
    SEND_CONVERT_LINK: (props) => renderSendLink(props),
    CUSTOM_FIELD_TYPE_SELECTION: (props) => renderCustomFieldTypeSelection(props),
    CUSTOM_FIELD_SETTINGS: (props) => renderCustomFieldSettings(props),
    SERIES_PAYMENT_OPTIONS: (props) => renderSeriesPaymentOptionsStep(props),
    CHOOSE_HUG_PAYMENT_TYPE: (props) => renderChoosePaymentOptionsStep(props),
    PAYMENT: (props) => renderPayment(props),
    SEND_ONE_TIME_MEMBERSHIP_LINK: (props) => renderSendLink(props),
    PERSONAL_DETAILS: (props) => renderPersonalDetails(props),
    LEAD_TO_CONVERT_PERSONAL_DETAILS: (props) => renderPersonalDetails(props),
    REQUIRED_FIELDS_SETTINGS: (props) => renderRequiredFieldsSettings(props),
    CHOOSE_GROUP_CONNECTION_USER: (props) => renderChooseGroupConnectionUser(props),
    GROUP_CONNECTION_ADD_USER: (props) => renderGroupConnectionAddUser(props),
    SITE_TRIAL_SETTINGS: (props) => renderSiteTrialSettings(props),
    GATES_APPLY_SETTINGS: (props) => renderGatesApplySettings(props),
    GATES_ACTIVITY_HOURS: (props) => renderGatesActivityHours(props),
    SITE_LEAD_FORM_SETTINGS: (props) => renderSiteLeadFormSettings(props),
    ADVANCED_SERIES_SETTINGS: (props) => renderAdvancedSeriesSettings(props),
    EXPORT: (props) => renderExport(props),
    SEND_INVOICES_REPORT: (props) => renderSendInvoicesReport(props),
    SEND_DOCTOR_JOURNAL_REPORT: (props) => renderSendDoctorJournalReport(props),
    NOTE_TEMPLATE: (props) => renderNoteTemplate(props),
    NOTE: (props) => renderNote(props),
    GROUP_DETAILS: (props) => renderGroupDetails(props),
    FLOW_FORM: (props) => renderFlowForm(props),
    SEND_DEBT_LINK: (props) => renderSendDebtLink(props),
    BUILD_UNIFORM_REPORT: (props) => renderBuildUniformReport(props),
    SEND_CONFIRMATION_LINK: (props) => renderSendConfirmationLink(props),
    BOOK_TO_HUG_CREATE_LEAD: (props) => renderPersonalDetails(props),
    USER_CHARGE_SETTING: (props) => renderUserChargeSetting(props),
    USER_NOTE_EXPORT: (props) => renderUserNoteExport(props),
    CHOOSE_HUG_TO_SWAP: (props) => renderChooseHug(props),
    BOOKING_TYPE: (props) => renderBookingType(props)
}

export const stepHeader = (props) => {
    const flowConfig = store.getState().stepper
    const isEdit = !!flowConfig.editType
    const prefix = isEdit ? (flowConfig.editType === SINGLE_SESSION_EDIT_TYPE ? 'edit-a' : 'edit-all') : 'add-a'
    const basicLabel = t(`${prefix}-${flowConfig.selectionsTree[optionalSteps.EVENT_TYPE] ?? 'session'}`)
    const multiDayConfigLabel = flowConfig.selectionsTree[optionalSteps.APPOINTMENT_OR_AVAILABILITY_STEP] ? t(`${prefix}-${flowConfig.selectionsTree[optionalSteps.APPOINTMENT_OR_AVAILABILITY_STEP]}`) : basicLabel;
    return {
        EVENT_TYPE: t(`${prefix}-session`),
        APPOINTMENT_OR_AVAILABILITY_STEP: basicLabel,
        BASIC_INFO: (flowConfig.name === flowOptions.APPOINTMENT_WITH_AVAILABILITY || flowConfig.name === flowOptions.APPOINTMENT_WITH_SPACE_AVAILABILITY) ? t(`${prefix}-appointment`) : basicLabel,
        REPEAT_CONFIG: basicLabel,
        AVAILABILITY_CONFIG: t(`${prefix}-appointment`),
        MULTI_DAY_CONFIG: flowConfig.name === flowOptions.SPACE_AVAILABILITY ? t('define-space-availability') : multiDayConfigLabel,
        SETTINGS: basicLabel,
        USER_AND_MEMBERSHIP_SELECTION: basicLabel,
        PAYMENT_METHOD_SELECTION: basicLabel,
        SUCCESS_PAGE: null,
        EDIT_MULTI_DAY_CONFIG: flowConfig.name === flowOptions.SPACE_AVAILABILITY ? t(`${prefix}-availability`) : multiDayConfigLabel,
        MEMBER_DETAILS: flowConfig.props.fromEventManage ? t('add-new-lead-event-manage') : t(snakeToCamel(`ADD_NEW_${(flowConfig.name)}`)),
        STAFF_MEMBER_ROLE_SELECT: t('addNewStaffMember'),
        BLOCKED_TIME: t('blocked-time'),
        MESSAGE_TYPE: t('select-message-type'),
        MESSAGE_DETAILS: t('send-message'),
        EMAIL_AFTER_PURCHASE: t('email-after-purchase-title'),
        SPACE_CONFIGURATION: t('add-space'),
        PENALTY_SETTINGS: flowConfig.props.target ? t('edit-penalty-title') : t('penalty-settings-title'),
        PENALTY_EXTRA_PROPERTIES: t('penalty-extra-properties-title'),
        PENALTY_SUMMARY: t('summary'),
        TASK_DETAILS: flowConfig.props.target?.id ? t('editTaskHeader') : t('addNewTaskHeader'),
        TASK_TYPE: flowConfig.props.target ? t('editTaskType') : t('createTaskType'),
        SEND_CONVERT_LINK: t('send-convert-link-header'),
        CUSTOM_FIELD_TYPE_SELECTION: t(`custom-fields-settings-header-${isEdit ? 'edit' : 'create'}`),
        CUSTOM_FIELD_SETTINGS: t(`custom-fields-settings-header-${isEdit ? 'edit' : 'create'}`),
        SERIES_PAYMENT_OPTIONS: t(`${isEdit ? 'edit-' : ''}series-payment-options-step-header`),
        CHOOSE_HUG_PAYMENT_TYPE: t('bookHugPaymentTypeHeader'),
        PAYMENT: flowConfig.name === flowOptions.CLOSE_MU_DEBT ? t('close-debt-step-header') : t('payment-step-header'),
        PERSONAL_DETAILS: t('bookNewMemberToHug'),
        REQUIRED_FIELDS_SETTINGS: t(`required-fields-settings-header${flowConfig.props.initProps?.type !== USER_FIELDS ? (`-${flowConfig.props?.initProps?.type}` ?? '') : ''}`),
        SEND_ONE_TIME_MEMBERSHIP_LINK: flowConfig.props.target?.showOnlyHugim ? t('send-hug-link-header') : flowConfig.props.target?.fromLeadProfile ? t('send-membership-link-header-lead-profile') : t('send-membership-link-header'),
        CHOOSE_GROUP_CONNECTION_USER: t('choose-group-connection-user-header'),
        GROUP_CONNECTION_ADD_USER: t(`${flowConfig.props.target?.groups_id ? 'existing' : 'new'}-group-connection-add${flowConfig?.flags.selection === 'existing' ? '-existing' : ''}-user-header`),
        SITE_TRIAL_SETTINGS: t('site-trial-settings-header'),
        GATES_APPLY_SETTINGS: t('gates-apply-settings-header'),
        GATES_ACTIVITY_HOURS: t('gates-activity-hours-header'),
        LEAD_TO_CONVERT_PERSONAL_DETAILS: t('convertLeadWithHugHeader'),
        SITE_LEAD_FORM_SETTINGS: t('lead-form-site-settings-header'),
        ADVANCED_SERIES_SETTINGS: t(`${isEdit ? 'edit-' : ''}advanced-series-settings-header`),
        EXPORT: t('export-to-foreign-software'),
        SEND_INVOICES_REPORT: t('send-invoices-report-header'),
        SEND_DOCTOR_JOURNAL_REPORT: t('doctorJournalExportTitle'),
        NOTE_TEMPLATE: t(`${isEdit ? 'edit-' : ''}note-template-header`),
        NOTE: getNoteHeader(props),
        GROUP_DETAILS: t('bookNewMemberToHug'),
        FLOW_FORM: t('hugim-form-header', {formName: flowConfig.props.initProps?.form?.name}),
        SEND_DEBT_LINK: t('send-debt-link-header'),
        BUILD_UNIFORM_REPORT: t('build-uniform-report-header'),
        SEND_CONFIRMATION_LINK: t('send-confirmation-link-header'),
        BOOK_TO_HUG_CREATE_LEAD: t('create-lead-book-to-hug-header'),
        USER_CHARGE_SETTING: t('user-charge-setting-header'),
        USER_NOTE_EXPORT: t('user-not-export-header'),
        CHOOSE_HUG_TO_SWAP: t('choose-hug-to-swap-header'),
        BOOKING_TYPE: t('booking-type-header')
    }
}

const getNoteHeader = (props) => {
    const flowConfig = store.getState().stepper
    const isEdit = !!flowConfig.editType
    const innerInitProps = store.getState().stepper?.props?.initProps
    const initProps = innerInitProps ?? props.initProps
    const editPrefix = isEdit ? 'edit-' : '';
    const noteType = initProps?.fromCreateEvent ? '' : (initProps?.isSingle || flowConfig.editType === SINGLE_SESSION_EDIT_TYPE ? 'schedule-' : 'series-')
    const noteTypePrefix = flowConfig.name === flowOptions.USER_NOTE ? 'user-' : noteType
    const isEmptySuffix = !initProps?.scheduleType ? '-empty' : ''
    return t(`${editPrefix}${noteTypePrefix}note-header${isEmptySuffix}`, {name: initProps?.scheduleType})
}

export const stepSubHeader = (has, target) => {
    const flowConfig = store.getState().stepper
    const isEdit = !!flowConfig.editType
    const type = flowConfig.selectionsTree[optionalSteps.EVENT_TYPE]
    const appointmentType = flowConfig.selectionsTree[optionalSteps.APPOINTMENT_OR_AVAILABILITY_STEP]
    let coach = null
    if(flowConfig.name === flowOptions.APPOINTMENT_WITH_AVAILABILITY) {
        const coachesStore = store.getState().schedule.coaches;
        coach = coachesStore.find(coachStore => coachStore.user_fk === target.coach.user_fk)
    }
    return {
        EVENT_TYPE: t('event-type-step-subheader'),
        APPOINTMENT_OR_AVAILABILITY_STEP: t('one-on-one-subheader'),
        BASIC_INFO: t(`basic-info-step-subheader${isEdit ? '-edit' : ''}`, {type: t(((flowConfig.name === flowOptions.APPOINTMENT_WITH_AVAILABILITY || flowConfig.name === flowOptions.APPOINTMENT_WITH_SPACE_AVAILABILITY) ? 'appointment' : (type === 'hugim' ? 'courses' : type)) + '-label')}),
        REPEAT_CONFIG: t(`repeat-config-step-subheader${isEdit ? '-edit' : ''}`),
        AVAILABILITY_CONFIG: coach ? t('availability-config-step-subheader-with-sync') : t('availability-config-step-subheader'),
        MULTI_DAY_CONFIG: t(`multi-day-config-step-subheader-${appointmentType ?? type}`),
        SETTINGS: t('settings-step-subheader'),
        USER_AND_MEMBERSHIP_SELECTION: t('user-and-membership-step-subheader'),
        PAYMENT_METHOD_SELECTION: t('payment-method-step-subheader'),
        SUCCESS_PAGE: null,
        EDIT_MULTI_DAY_CONFIG: t(`edit-multi-day-config-step-subheader-${flowConfig.name === flowOptions.SPACE_AVAILABILITY ? 'space' : appointmentType ?? type}`),
        MEMBER_DETAILS: '',
        STAFF_MEMBER_ROLE_SELECT: t('addNewStaffMemberRolesInfo'),
        BLOCKED_TIME: '',
        MESSAGE_TYPE: t('select-message-type-subheader'),
        MESSAGE_DETAILS: '',
        EMAIL_AFTER_PURCHASE: t('email-after-purchase-info'),
        SPACE_CONFIGURATION: t('add-space-subheader'),
        PENALTY_SETTINGS: t('penalty-settings-subtitle'),
        PENALTY_EXTRA_PROPERTIES: t('penalty-extra-properties-subtitle'),
        PENALTY_SUMMARY: '',
        TASK_DETAILS: '',
        SEND_CONVERT_LINK: t('send-convert-link-subheader'),
        CUSTOM_FIELD_TYPE_SELECTION: t(`custom-fields-add-subheader`),
        CUSTOM_FIELD_SETTINGS: t(`custom-fields-settings-subheader-${isEdit ? 'edit' : 'create'}`),
        SERIES_PAYMENT_OPTIONS: t(`${isEdit ? 'edit-' : ''}series-payment-options-step-subheader`),
        CHOOSE_HUG_PAYMENT_TYPE: t('bookHugPaymentTypeSubheader'),
        SEND_ONE_TIME_MEMBERSHIP_LINK: flowConfig.props.target?.showOnlyHugim ? t('hugim-purchase-leads') : (flowConfig.props.target?.fromLeadProfile ? t('send-membership-link-subheader-leads') : (has('hugim') ? t('send-membership-link-subheader-hugim') : t('send-membership-link-subheader'))),
        PERSONAL_DETAILS: t('bookNewMemberToHugSubheader'),
        TASK_TYPE: '',
        REQUIRED_FIELDS_SETTINGS: t(`required-fields-settings-subheader${flowConfig.props.initProps?.type !== USER_FIELDS ? (`-${flowConfig.props?.initProps?.type}` ?? '') : ''}`),
        CHOOSE_GROUP_CONNECTION_USER: t('choose-group-connection-user-subheader'),
        GROUP_CONNECTION_ADD_USER: t(`group-connection-add${flowConfig?.flags.selection === 'existing' ? '-existing' : ''}-user-subheader`),
        SITE_TRIAL_SETTINGS: t('site-trial-settings-subheader'),
        GATES_APPLY_SETTINGS: t('gates-apply-settings-subheader'),
        GATES_ACTIVITY_HOURS: t('gates-activity-hours-subheader'),
        LEAD_TO_CONVERT_PERSONAL_DETAILS: t('convertLeadWithHugSubheader'),
        SITE_LEAD_FORM_SETTINGS: t('lead-form-site-settings-subheader'),
        ADVANCED_SERIES_SETTINGS: t(`${isEdit ? 'edit-' : ''}advanced-series-settings-subheader`),
        SEND_INVOICES_REPORT: t('send-invoices-report-subheader', {dateRange: flowConfig.props.dates?.replace(/\./g, '/')}),
        SEND_DOCTOR_JOURNAL_REPORT: null,
        NOTE_TEMPLATE: null,
        NOTE: null,
        GROUP_DETAILS: t('bookGroupToHugSubheader'),
        FLOW_FORM: t('hugim-form-subheader'),
        BUILD_UNIFORM_REPORT: t('build-uniform-report-subheader'),
        SEND_DEBT_LINK: t(`send-debt-link-subheader${flowConfig.props?.target?.type === 'reports' ? '-reports' : ''}`),
        SEND_CONFIRMATION_LINK: t('send-confirmation-link-subheader'),
        BOOK_TO_HUG_CREATE_LEAD: t('create-lead-details-subheader'),
        USER_CHARGE_SETTING: t('user-charge-setting-subheader'),
        USER_NOTE_EXPORT: t('user-not-export-subheader'),
        CHOOSE_HUG_TO_SWAP: t('choose-hug-to-swap-subheader'),
        BOOKING_TYPE: t('booking-type-subheader')
    }
}

export const shouldConsiderInProgressBar = () => {
    const flowConfig = store.getState().stepper
    return {
        EVENT_TYPE: false,
        APPOINTMENT_OR_AVAILABILITY_STEP: false,
        BASIC_INFO: true,
        REPEAT_CONFIG: true,
        AVAILABILITY_CONFIG: true,
        MULTI_DAY_CONFIG: true,
        SETTINGS: true,
        USER_AND_MEMBERSHIP_SELECTION: true,
        PAYMENT_METHOD_SELECTION: false,
        SUCCESS_PAGE: false,
        EDIT_MULTI_DAY_CONFIG: true,
        MEMBER_DETAILS: false,
        STAFF_MEMBER_ROLE_SELECT: false,
        BLOCKED_TIME: false,
        MESSAGE_TYPE: false,
        MESSAGE_DETAILS: false,
        EMAIL_AFTER_PURCHASE: false,
        SPACE_CONFIGURATION: false,
        CUSTOM_FIELD_TYPE_SELECTION: false,
        CUSTOM_FIELD_SETTINGS: false,
        SERIES_PAYMENT_OPTIONS: true,
        CHOOSE_HUG_PAYMENT_TYPE: flowConfig.name === flowOptions.SWAP_HUG_REGISTRATION ? false : true,
        PAYMENT: true,
        PERSONAL_DETAILS: true,
        LEAD_TO_CONVERT_PERSONAL_DETAILS: true,
        ADVANCED_SERIES_SETTINGS: true,
        NOTE_TEMPLATE: false,
        NOTE: false,
        GROUP_DETAILS: true,
        FLOW_FORM: false,
        BOOK_TO_HUG_CREATE_LEAD: true,
        CHOOSE_HUG_TO_SWAP: true,
        BOOKING_TYPE: true
    }
}

export const showProgressBar = ({
    EVENT_TYPE: false,
    APPOINTMENT_OR_AVAILABILITY_STEP: false,
    BASIC_INFO: true,
    REPEAT_CONFIG: true,
    AVAILABILITY_CONFIG: true,
    MULTI_DAY_CONFIG: true,
    SETTINGS: true,
    USER_AND_MEMBERSHIP_SELECTION: true,
    PAYMENT_METHOD_SELECTION: true,
    SUCCESS_PAGE: false,
    EDIT_MULTI_DAY_CONFIG: true,
    MEMBER_DETAILS: false,
    STAFF_MEMBER_ROLE_SELECT: false,
    BLOCKED_TIME: false,
    MESSAGE_TYPE: false,
    MESSAGE_DETAILS: false,
    EMAIL_AFTER_PURCHASE: false,
    SPACE_CONFIGURATION: false,
    CUSTOM_FIELD_TYPE_SELECTION: false,
    CUSTOM_FIELD_SETTINGS: false,
    SERIES_PAYMENT_OPTIONS: true,
    CHOOSE_HUG_PAYMENT_TYPE: true,
    PAYMENT: true,
    PERSONAL_DETAILS: true,
    LEAD_TO_CONVERT_PERSONAL_DETAILS: true,
    ADVANCED_SERIES_SETTINGS: true,
    EXPORT: false,
    SEND_INVOICES_REPORT: false,
    SEND_DOCTOR_JOURNAL_REPORT: false,
    NOTE_TEMPLATE: false,
    NOTE: false,
    GROUP_DETAILS: true,
    FLOW_FORM: false,
    BOOK_TO_HUG_CREATE_LEAD: true,
    CHOOSE_HUG_TO_SWAP: true,
    BOOKING_TYPE: true
})

export const overrideCurrentValues = (stepName) => {
    const flowConfig = store.getState().stepper
    switch (stepName) {
        case optionalSteps.APPOINTMENT_OR_AVAILABILITY_STEP:
        case optionalSteps.EVENT_TYPE:
            return false
        case optionalSteps.SETTINGS:
            return flowConfig.flags.overrideValues ? false : true
        default:
            return true
    }
}

export const stepValidationSchema = () => ({
    EVENT_TYPE: yup.object().shape({}),
    BASIC_INFO: getBasicInfoValidationSchema(),
    REPEAT_CONFIG: getRepeatConfigValidationSchema(),
    AVAILABILITY_CONFIG: getAvailabilityConfigValidationSchema(),
    MULTI_DAY_CONFIG: getMultiDayConfigValidationSchema(),
    SETTINGS: yup.object().shape({
        transparent: yup.boolean().required(t('thisFieldIsMandatory')),
        disable_cancellation_time: yup.number().min(0).required(t('thisFieldIsMandatory')),
        enable_late_cancellation: yup.boolean().required(t('thisFieldIsMandatory')),
        cancel_limit: yup.number().nullable(),
        min_users: yup.number().integer().nullable(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        live_link: yup.string().nullable(),
        register_group_member: yup.boolean().required(t('thisFieldIsMandatory')),
        allow_mid_booking: yup.boolean().required(t('thisFieldIsMandatory')),
        block_registration_time: yup.number().when(['enable_registration_time'], (enable_registration_time, schema) => {
            return schema.test({
                test: blockRegistrationTime => blockRegistrationTime < enable_registration_time || blockRegistrationTime === 0 || enable_registration_time === 0,
                message: t('enableRegistrationSmallerOrEqualToBlock')
            })
        }),
        enable_registration_time: yup.number()
    }),
    USER_AND_MEMBERSHIP_SELECTION: yup.object().shape({
        scheduleUser: yup.object().shape({
            user_fk: yup.number().positive().required(t('thisFieldIsMandatory')),
            membership_user_fk: yup.number().positive()
                .when(['isLead', 'paymentObject', 'isNoMembership'], (isLead, paymentObject, isNoMembership) => (isLead === false && paymentObject === null && isNoMembership === false) ? yup.number().positive().required(t('thisFieldIsMandatory')) : yup.number().nullable()),
            isLead: yup.boolean().required(),
            paymentObject: yup.object().shape({
                cart: yup.object().shape({}).required(),
                method: yup.string().oneOf([ENTER_DEBT, FREE_PURCHASE])
            }).nullable(),
            force: yup.boolean().required(),
            sendInvitation: yup.boolean().required(),
            isNoMembership: yup.boolean().required()
        })
    }),
    PAYMENT_METHOD_SELECTION: yup.object().shape({}),
    SUCCESS_PAGE: yup.object().shape({}),
    EDIT_MULTI_DAY_CONFIG: getEditMultiDaysValidationSchema(),
    MEMBER_DETAILS: getUserDetailsBaseValidationSchema(),
    STAFF_MEMBER_ROLE_SELECT:  yup.object().shape({
        roles: yup.array(yup.string()).min(1, t('staff-roles-choose-at-least-one'))
    }),
    BLOCKED_TIME: getBlockedTimeValidationSchema(),
    MESSAGE_TYPE: yup.object().shape({
        type: yup.string().required(t('thisFieldIsMandatory')).oneOf([PUSH, SMS, EMAIL, WHATSAPP])
    }),
    MESSAGE_DETAILS: getMessageDetailsValidationSchema(),
    EMAIL_AFTER_PURCHASE: yup.object().shape({
        locations_box_id: yup.number().required(),
        membership_types: yup.array(yup.object().shape({
            id: yup.number().required()
        })).test('memberships', t('select-at-least-one-membership'), function (value) {
            return value?.filter?.(mt => mt.location_box_fk == this.parent.locations_box_id)?.length > 0 || this.parent.trial_class
        }),
        users_boxes: yup.array(yup.object().shape({
            id: yup.number().required()
        })).min(1, t('select-at-least-one-staff-member')),
        trial_class: yup.boolean()
    }),
    SPACE_CONFIGURATION: getSpaceConfigValidationSchema(),
    PENALTY_SETTINGS: getPenaltiesSettingsValidationSchema(),
    PENALTY_EXTRA_PROPERTIES: getExtraPenaltiesPropertiesValidationSchema(),
    TASK_DETAILS: yup.object().shape({
        reminder_time: yup.string().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        user_fk: yup.number().integer().nullable().when('targeted', {
            is: value => value === targetAudienceTasks.SPECIFIC_USER,
            then: yup.number().min(1).required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory'))
        }),
        task_type_fk: yup.number().integer().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        assigned_to: yup.number().integer().nullable(),
        description: yup.string().test('no-emojis', t('no-emojis-are-allowed-task-desc'), isStringWithoutEmoji),
        locations_box_fk: yup.number().integer().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        done: yup.boolean().nullable(),
        targeted: yup.string(),
        check_in: yup.boolean(),
        access_control: yup.boolean(),
        is_personal: yup.number()
    }),
    TASK_TYPE: yup.object().shape({
        type: yup.string().required(),
        check_in: yup.boolean(),
        access_control: yup.boolean(),
        task_type_color: yup.string()

    }),
    SEND_CONVERT_LINK: getSendConvertLinkValidationSchema(),
    CUSTOM_FIELD_TYPE_SELECTION: yup.object().shape({customFieldType: yup.string().required().oneOf([SCHEDULE_TYPE, USER_TYPE])}),
    CUSTOM_FIELD_SETTINGS: yup.object().shape({
        customFieldName: yup.string()
            .required(t('thisFieldIsMandatory'))
            .typeError(t('thisFieldIsMandatory'))
            .min(2, t('customFieldNameMinMaxError'))
            .max(30, t('customFieldNameMinMaxError'))
            .test(
                'unique-name',
                t('nameAlreadyExistsError'),
                (value) =>  {
                    const target = store.getState().stepper.props?.target;
                    const originalField = target ? {id: target.custom_field_id, name: target.customFieldName} : null;
                    const customFieldsNames = store.getState().schedule.scheduleCustomFields?.filter(field => originalField ? originalField.id !== field.custom_field_id : field).map(field => field.custom_field_name);
                    return !customFieldsNames?.includes(value);
                }
            ),
        inputType: yup.string().when('customFieldType', {
            is: value => value === SCHEDULE_TYPE,
            then: yup.string().required(t('thisFieldIsMandatory')).oneOf([customFieldTypes.SELECT]),
            otherwise: yup.string().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory'))
        }),
        locations: yup.array().min(1, t('mustChooseAtLeastOneLocationError')).required(),
        flows: yup.array()
            .min(1, t('mustChooseAtLeastOneFlowError'))
            .test('at-least-one-checked', t('mustChooseAtLeastOneFlowError'), function(value) {
                return value?.some(flow => flow.checked === true);
            })
            .required(),
        props: yup.object().when('inputType', {
            is: customFieldTypes.SELECT,
            then: yup.object().shape({
                options: yup.array(yup.object().shape({
                    value: yup.string().required(t('thisFieldIsMandatory'))
                })).min(2, t('mustSetAtLeastTwoOptionsError')).required()
            }),
            otherAttribute: yup.mixed().test(
                'has-min-options',
                t('mustSetAtLeastTwoOptionsError'),
                function(value) {
                    const { options } = this.parent;
                    return options && options.length >= 2;
                }
            )
        })
    }),
    SERIES_PAYMENT_OPTIONS: yup.object().shape({
        paymentOptions: yup.array(yup.object().shape({
            type: yup.string().oneOf([HOK, TRIAL, IMMEDIATE]),
            relative_payment: yup.string().oneOf([RELATIVE, FULL, null]).nullable(),
            show_in_app: yup.number().integer().min(0).max(3),
            max_installments: yup.number().integer().min(1).max(24).typeError(t('thisFieldIsMandatory')),
            price: yup.number().when('type', {
                is: type => type === HOK,
                then: yup.number().min(1, t('price-zero-invalid')).required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
                otherwise: yup.number().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory'))
            }),
            taxes: yup.array().of(yup.number().required(t('thisFieldIsMandatory'))).ensure(),
        })),
        sort_code: yup.number().nullable().min(100, t('sort-code-must-have-3-digits')).max(999, t('sort-code-must-have-3-digits'))
    }),
    ADVANCED_SERIES_SETTINGS: yup.object().shape({
        paymentOptions: yup.array(yup.object().shape({
            type: yup.string().oneOf([HOK, TRIAL, IMMEDIATE]),
            addons: yup.array().of(yup.number()).ensure()
        })),
        partialOptions: yup.array().when(['multiDayConfig'], multiDayConfig => {
            if(multiDayConfig?.days?.length > 1) {
                return yup.array(yup.object().shape({
                    type: yup.string().oneOf([HOK, IMMEDIATE]),
                    show_in_app: yup.number().integer().min(0).max(3),
                    max_installments: yup.number().integer().min(1).max(24).typeError(t('thisFieldIsMandatory')),
                    price: yup.number().when('type', {
                        is: type => type === HOK,
                        then: yup.number().min(1, t('price-zero-invalid')).required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
                        otherwise: yup.number().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory'))
                    }),
                    taxes: yup.array().of(yup.number().required(t('thisFieldIsMandatory'))).ensure(),
                    daysOfWeek: yup.number().integer().min(1).max((multiDayConfig?.days?.length - 1) || 1),
                    name: yup.string().required(t('thisFieldIsMandatory'))
                }))
            }
            else return yup.array().nullable()
        }),
        form_id: yup.number().nullable()
    }),
    CHOOSE_HUG_PAYMENT_TYPE: yup.object().shape({
        cart: yup.array().of(yup.object().shape({
            id: yup.number().required(t('selectPaymentTypeError')).typeError(t('selectPaymentTypeError')),
        }))
    }),
    PAYMENT: yup.object().shape({
        payment_info: yup.object().required(),
    }),
    PERSONAL_DETAILS: getUserDetailsBaseValidationSchema('member'),
    LEAD_TO_CONVERT_PERSONAL_DETAILS: getUserDetailsBaseValidationSchema('member'),
    REQUIRED_FIELDS_SETTINGS: getRequiredFieldsSettingsValidationSchema(),
    SEND_ONE_TIME_MEMBERSHIP_LINK: getSendMembershipLinkValidationSchema(),
    CHOOSE_GROUP_CONNECTION_USER: yup.object().shape({
        selection: yup.string().required().oneOf(['existing', 'new'])
    }),
    GROUP_CONNECTION_ADD_USER: getGroupConnectionAddUserValidationSchema(),
    SITE_TRIAL_SETTINGS: yup.object().shape({
        newLead: yup.object().shape({
            status_id: yup.number().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
            source_id: yup.number().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory'))
        }),
        existingLead: yup.object().shape({
            status_id: yup.number().nullable().typeError(t('thisFieldIsMandatory')),
            source_id: yup.number().nullable().typeError(t('thisFieldIsMandatory'))
        })
    }),
    GATES_APPLY_SETTINGS: yup.object().shape({
        apply: yup.string().oneOf(['all', 'each'])
    }),
    GATES_ACTIVITY_HOURS: yup.object().shape({}),
    SITE_LEAD_FORM_SETTINGS: siteLeadFormSettingsValidationSchema(),
    EXPORT: getExportValidationSchema(),
    SEND_INVOICES_REPORT: getSendInvoicesValidationSchema(),
    SEND_DOCTOR_JOURNAL_REPORT: getSendDoctorJournalReportValidationSchema(),
    NOTE_TEMPLATE: yup.object().shape({
        name: yup.string().required(t('thisFieldIsMandatory')).max(40, t('field-string-length-error', {length: '40'})),
        content: yup.string().required(t('thisFieldIsMandatory')).test(
            'has-content',
            t('thisFieldIsMandatory'),
            (value) => {
                if (!value) return false;
                const textOnly = value.replace(/<[^>]*>/g, '').trim();
                return textOnly !== '';
            }
        ),
        scope: yup.string().required().oneOf([messageTemplateScopes.NOTE]),
        id: yup.number().nullable()
    }),
    NOTE: getNoteValidationSchema(),
    GROUP_DETAILS: yup.object().shape({
        isChildRegistration: yup.boolean(),
        child: courseChildDetailsValidationSchema(),
        parent: yup.object().when('isChildRegistration', {
            is: true,
            then: getUserDetailsBaseValidationSchema('member'),
            otherwise: yup.object()
        })
    }),
    FLOW_FORM: yup.object().shape({
        hugimType: yup.object().shape({
            id: yup.number().nullable(),
            form_id: yup.number().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
            hugim: yup.array().of(yup.number()),
            allowTrial: yup.boolean(),
        }),
        groupType: yup.object().shape({
            id: yup.number().nullable(),
            form_id: yup.number().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
            box_categories: yup.array().of(yup.number()),
            allowTrial: yup.boolean(),
        })
    }),
    SEND_DEBT_LINK: getDebtLinkValidationSchema(),
    BUILD_UNIFORM_REPORT: yup.object().shape({
        tax_year: yup.string().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory'))
    }),
    SEND_CONFIRMATION_LINK: getConfirmationLinkValidationSchema(),
    BOOK_TO_HUG_CREATE_LEAD: getUserDetailsBaseValidationSchema('lead'),
    USER_CHARGE_SETTING: getUserChargeSettingValidationSchema(),
    USER_NOTE_EXPORT: getUserNoteExportValidationSchema(),
    CHOOSE_HUG_TO_SWAP: yup.object().shape({
        eventData: yup.object().shape({
            series: yup.object().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
            date: yup.string().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory'))
        })
    }),
    BOOKING_TYPE: yup.object().shape({
        bookingType: yup.string().required(t('thisFieldIsMandatory')),
        selectedSeriesEvents: yup.array().of(yup.number()).nullable()
            .when('bookingType', (bookingType, schema) => {
                if (bookingType?.startsWith(HUG_PARTIAL_BOOKING)) {
                    const requiredCount = parseInt(bookingType.split('_').pop(), 10);
                    return schema
                        .required(t('thisFieldIsMandatory'))
                        .typeError(t('thisFieldIsMandatory'))
                        .length(requiredCount, t('thisFieldIsMandatory'));
                }
                return schema.length(0, t('thisFieldIsMandatory'));
            }),
        cancelReasonId: yup.number().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory'))
    }),
})

export const stepInitialValues = ({eventDateTime, target, initProps}) => {
    const selectedTime = eventDateTime?.start ?? moment().startOf('hour').format(dbTimeFormat)
    const selectedDay = eventDateTime?.date ? moment(eventDateTime?.date, dbDateFormat).day() : moment().day()
    const flowName = store.getState().stepper.name
    const defaultLocation = store.getState().user.user.locations_box_fk
    return {
        EVENT_TYPE: {},
        BASIC_INFO: getBasicInfoInitialValues(target, initProps),
        REPEAT_CONFIG: getRepeatInitialValues(target, eventDateTime, selectedTime, selectedDay, flowName),
        AVAILABILITY_CONFIG: getAvailabilityConfigInitialValues(target, eventDateTime, selectedDay),
        MULTI_DAY_CONFIG: getMultiDayConfigInitialValues(eventDateTime, selectedDay, initProps),
        SETTINGS: getSettingsInitialValues(target),
        USER_AND_MEMBERSHIP_SELECTION: {
            scheduleUser: {
                user_fk: null,
                membership_user_fk: null,
                isLead: false,
                paymentObject: null,
                force: false,
                sendInvitation: true,
                isNoMembership: false
            }
        },
        PAYMENT_METHOD_SELECTION: {},
        SUCCESS_PAGE: {},
        EDIT_MULTI_DAY_CONFIG: getEditMultiDaysInitialValues(eventDateTime, target),
        MEMBER_DETAILS: getUserDetailsBaseInitialValues(target),
        STAFF_MEMBER_ROLE_SELECT: {
            roles: initProps?.roles ?? store.getState().stepper?.props?.initProps?.roles ?? [] // tbh i dont like it, but initProps is not correct
        },
        BLOCKED_TIME: {
            scheduleTarget: target ?? null,
            coach_fk: target?.coach_fk ?? initProps?.coach_fk ?? null,
            locations_box_fk: target?.locations_box_fk ?? null,
            place: target?.place ?? '',
            spaces_id: target?.spaces_id ?? initProps?.spaces_id ?? null,
            ...getRepeatInitialValues(target, eventDateTime, selectedTime, selectedDay, flowName),
        },
        MESSAGE_TYPE: {
            type: target?.selectedType || ((target?.type === 'reports') && (target?.messageTypes?.includes(PUSH) ? PUSH : SMS)) || PUSH,
            targetType: target?.type || null
        },
        MESSAGE_DETAILS: {},
        EMAIL_AFTER_PURCHASE: getEmailAfterPurchaseInitialValues(target),
        SPACE_CONFIGURATION: {
            locations_box_id: null,
            name: '',
            availabilityInfo: null
        },
        PENALTY_SETTINGS: getPenaltySettingsInitialValues(target),
        PENALTY_EXTRA_PROPERTIES: getPenaltyExtraPropertiesInitialValues(target),
        TASK_DETAILS: getTaskDetailsInitialValues(target),
        TASK_TYPE: getCreateTaskTypeInitialValues(target),
        SEND_CONVERT_LINK: getSendConvertLinkInitialValues(target),
        CUSTOM_FIELD_TYPE_SELECTION: {customFieldType: USER_TYPE},
        CUSTOM_FIELD_SETTINGS: getCustomFieldSettingsInitialValues(target),
        SERIES_PAYMENT_OPTIONS: getSeriesPaymentOptionsInitialValues(target),
        CHOOSE_HUG_PAYMENT_TYPE: { cart: null},
        PAYMENT: {payment_info: null},
        PERSONAL_DETAILS: getUserDetailsBaseInitialValues(target),
        REQUIRED_FIELDS_SETTINGS: getRequiredFieldsSettingsInitialValues(initProps),
        SEND_ONE_TIME_MEMBERSHIP_LINK: getSendMembershipLinkInitialValues(target),
        CHOOSE_GROUP_CONNECTION_USER: {selection: 'existing'},
        LEAD_TO_CONVERT_PERSONAL_DETAILS: getUserDetailsBaseInitialValues(target),
        GROUP_CONNECTION_ADD_USER: getGroupConnectionAddUserInitialValues(target),
        SITE_TRIAL_SETTINGS: getSiteTrialSettingsInitialValues(),
        GATES_APPLY_SETTINGS: {apply: 'all'},
        GATES_ACTIVITY_HOURS: getGatesActivityHoursInitialValues(),
        SITE_LEAD_FORM_SETTINGS: getLeadFormSiteSettingsInitialValues(),
        ADVANCED_SERIES_SETTINGS: getSeriesPartialOptionsInitialValues(target),
        EXPORT: getExportInitialValues(),
        SEND_INVOICES_REPORT: getSendInvoicesReportInitialValues(),
        SEND_DOCTOR_JOURNAL_REPORT: getSendDoctorJournalReportInitialValues(initProps),
        NOTE_TEMPLATE: {
            id: target?.id ?? null,
            name: target?.name ?? '',
            content: target?.text ?? '',
            scope: messageTemplateScopes.NOTE
        },
        NOTE: getNoteInitialValues({target, ogInitProps: initProps}),
        GROUP_DETAILS: {
            child: getUserDetailsBaseInitialValues(target, true),
            parent: getUserDetailsBaseInitialValues(target, false, true),
            locations_box_fk: defaultLocation,
            isChildRegistration: true
        },
        FLOW_FORM: getFlowFormInitialValues({target, ogInitProps: initProps}),
        SEND_DEBT_LINK: getDebtLinkInitialValues({target, initProps}),
        BUILD_UNIFORM_REPORT: {
            tax_year: null
        },
        SEND_CONFIRMATION_LINK: getSendConfirmationLinkInitialValues({target, initProps}),
        BOOK_TO_HUG_CREATE_LEAD: getUserDetailsBaseInitialValues(target),
        USER_CHARGE_SETTING: getUserChargeSettingInitialValues(initProps),
        USER_NOTE_EXPORT: getUserNoteExportInitialValues({target}),
        CHOOSE_HUG_TO_SWAP: {
            eventData: null
        },
        BOOKING_TYPE: {
            bookingType: HUG_FULL_BOOKING,
            selectedSeriesEvents: null,
            cancelReasonId: null
        }
    }
}

export const onNextStep = ({
    EVENT_TYPE: ({dispatch}) => updateSelectionTree(dispatch),
    APPOINTMENT_OR_AVAILABILITY_STEP: ({dispatch}) => updateSelectionTree(dispatch),
    BASIC_INFO: () => console.log('onNext BASIC_INFO'),
    REPEAT_CONFIG: ({dispatch, onSave}) => checkDateTimeLimitations(dispatch, onSave),
    AVAILABILITY_CONFIG: () => console.log('onNext AVAILABILITY_CONFIG'),
    MULTI_DAY_CONFIG: ({dispatch, onSave}) => checkDateTimeLimitations(dispatch, onSave),
    SETTINGS: () => console.log('onNext SETTINGS'),
    USER_AND_MEMBERSHIP_SELECTION: ({dispatch}) => updateSelectionTree(dispatch),
    PAYMENT_METHOD_SELECTION: () => console.log('onNext PAYMENT_METHOD_SELECTION'),
    SUCCESS_PAGE: null,
    EDIT_MULTI_DAY_CONFIG: ({dispatch, onSave}) => checkDateTimeLimitations(dispatch, onSave),
    MEMBER_DETAILS: ({dispatch}) => memberDetailsOnNext(dispatch),
    SPACE_CONFIGURATION: () => null,
    CUSTOM_FIELD_TYPE_SELECTION: () => null,
    CUSTOM_FIELD_SETTINGS: () => null,
    SERIES_PAYMENT_OPTIONS: () => null,
    CHOOSE_HUG_PAYMENT_TYPE: () => console.log('onNext CHOOSE_HUG_PAYMENT_TYPE'),
    PERSONAL_DETAILS: () => console.log('onNext PERSONAL_DETAILS'),
    LEAD_TO_CONVERT_PERSONAL_DETAILS: ({dispatch}) => convertLeadOnNextStep(dispatch)
})

export const onBack = ({
    USER_AND_MEMBERSHIP_SELECTION: ({dispatch}) => dispatch(updateTempSelection(null)),
    BOOKING_TYPE: ({ formik }) => {
        formik?.setValues({
            ...formik.values,
            bookingType: HUG_FULL_BOOKING,
            selectedSeriesEvents: null,
            cancelReasonId: null,
        });
    },
})

const renderEventTypeSelectionStep = (props) => {
    return <EventTypeStep initSelection={props?.initSelection || null}/>
}

const renderAppointmentOrAvailabilityStep = (props) => {
    return <OneOnOneType {...props}/>
}

const renderBasicInfoStep = (props) => {
    const flowName = store.getState().stepper?.name
    const editType = store.getState().stepper?.editType
    const fromAvailability = (flowName === flowOptions.APPOINTMENT_WITH_AVAILABILITY || flowName === flowOptions.APPOINTMENT_WITH_SPACE_AVAILABILITY)
    let additional = {}

    additional.showMaxUsersTooltip = true;
    additional.showSpaces = (props?.hasPermission('spaces') && !props?.hasPermission('spacesLock'));
    additional.showCoach = true;
    additional.showSeasons = flowName === flowOptions.HUGIM_FLOW && props?.hasPermission('seasons') && editType !== SINGLE_SESSION_EDIT_TYPE; //show on create hug or edit series
    additional.allowMultiSpaces = props?.hasPermission('multiSpaces')

    if(flowName === flowOptions.APPOINTMENT_BASIC && editType) {
        const box = store.getState().box?.box
        additional.disableLocation = box?.hasInvoiceSeparation || props?.target?.availability_id
    }
    if(fromAvailability && props.values.locations_box_fk) {
        additional.disableLocation = true
    }
    if(flowName === flowOptions.WORKSHOP_FLOW && editType) {
        additional.disableService = true
        additional.disableLocation = editType === SERIES_FUTURE_SESSIONS_EDIT_TYPE
    }
    if(flowName === flowOptions.GROUP_CLASS_FLOW && editType) {
        additional.serviceChangeAlert = true
    }
    if(flowName === flowOptions.APPOINTMENT_WITH_AVAILABILITY && editType) {
        additional.disableLocation = true
        additional.disableService = true
        additional.disableCoach = true
        additional.showCoach = true
    }
    if(flowName === flowOptions.APPOINTMENT_WITH_SPACE_AVAILABILITY && !editType) {
        additional.showCoach = false
        additional.disableSpace = true
        additional.disableLocation = true
    }
    if(flowName === flowOptions.APPOINTMENT_WITH_SPACE_AVAILABILITY && editType) {
        additional.disableLocation = true
        additional.disableService = true
        additional.disableSpace = true
        additional.showSpaces = true
        additional.showCoach = false;
    }
    if(flowName === flowOptions.WORKSHOP_FLOW || flowName === flowOptions.HUGIM_FLOW) {
        additional.showMaxUsersTooltip = false
    }
    if(editType && flowName === flowOptions.HUGIM_FLOW) {
        additional.disableLocation = true
    }
    if(fromAvailability || flowName === flowOptions.BLOCKED_TIME) {
        additional.allowMultiSpaces = false
    }
    return <BasicInformation showLiveLinkSetting={flowName === flowOptions.APPOINTMENT_BASIC || fromAvailability} fromAvailability={fromAvailability} {...additional} {...props}/>
}

const renderRepeatConfigStep = (props) => {
    const flowName = store.getState().stepper?.name
    return <RepeatConfiguration allowSeries={flowName !== flowOptions.APPOINTMENT_BASIC} {...props}/>
}

export const renderAvailabilityConfigStep = (props) => {
    const editType = store.getState().stepper?.editType
    let additional = {
        disableDate: editType === null
    }
    return <AvailabilitySlotSelection {...additional} {...props}/>
}

const renderSettingsStep = (props) => {
    const flowName = store.getState().stepper.name
    const editType = store.getState().stepper?.editType

    let additional = {}
    switch (flowName) {
        case flowOptions.GROUP_CLASS_FLOW:
            additional.showTransparentSettings = true;
            additional.showSpots = true;
            additional.showCancellationSettings = true;
            additional.showRegistrationRestrictionsSettings = true;
            additional.showRegistrationBlockSettings = true;
            additional.showMinimumParticipantsSettings = true;
            additional.showGroupRegisterSettings = false;
            additional.showOnlineSessionSettings = true;
            additional.showSeriesNameSettings = (props?.values.repeatConfig?.repeat && (props?.values.repeatConfig.type === 'forever') && props?.values.repeatConfig.days.length === 1) || (editType === SERIES_FUTURE_SESSIONS_EDIT_TYPE && props?.target?.series_fk);
            additional.showBookForTrialSettings = props?.values.repeatConfig?.repeat || (editType === SERIES_FUTURE_SESSIONS_EDIT_TYPE && props?.target?.series_fk)
            break;
        case flowOptions.WORKSHOP_FLOW:
            additional.showTransparentSettings = false;
            additional.showCancellationSettings = false;
            additional.showRegistrationRestrictionsSettings = false;
            additional.showRegistrationBlockSettings = false;
            additional.showMinimumParticipantsSettings = false;
            additional.showGroupRegisterSettings = (props?.hasPermission('allowRegisterGroupMember') && editType !== SINGLE_SESSION_EDIT_TYPE) ?? false;
            additional.showOnlineSessionSettings = true;
            additional.showSeriesNameSettings = editType !== SINGLE_SESSION_EDIT_TYPE;
            break;
        case flowOptions.HUGIM_FLOW:
            additional.showTransparentSettings = false;
            additional.showCancellationSettings = false;
            additional.showRegistrationRestrictionsSettings = false;
            additional.showRegistrationBlockSettings = false;
            additional.showMinimumParticipantsSettings = false;
            additional.showOnlineSessionSettings = true;
            additional.showSeriesNameSettings = editType !== SINGLE_SESSION_EDIT_TYPE;
            additional.showGroupRegisterSettings = (props?.hasPermission('allowRegisterGroupMember') && editType !== SINGLE_SESSION_EDIT_TYPE) ?? false;
            additional.defaultOpenedSection = 'seriesNameSetting';
            additional.showMidBookingSettings = editType !== SINGLE_SESSION_EDIT_TYPE && !props?.values?.isOneDay;
            break;
    }
    return <SessionSettings displayProps={additional} {...props}/>
}

const renderMultiDayConfigStep = (props) => {
    const flowName = store.getState().stepper.name
    const editType = store.getState().stepper?.editType
    let additional = {}
    additional.showCoachSelect = flowName !== flowOptions.SPACE_AVAILABILITY
    additional.showSpacesSelect = flowName === flowOptions.SPACE_AVAILABILITY
    additional.servicesTypeOverride = flowName === flowOptions.SPACE_AVAILABILITY ? APPOINTMENT : null
    additional.showLocationSelect = flowName === flowOptions.AVAILABILITY
    additional.showUnlimitedOption = flowName === flowOptions.HUGIM_FLOW && props?.hasPermission('recurringPaymentActions')
    additional.showShortenName = flowName === flowOptions.HUGIM_FLOW
    additional.updateDatesBySeason = flowName === flowOptions.HUGIM_FLOW && props?.hasPermission('seasons') && !editType; //update dates only on create hug
    additional.showDayDescription = flowName === flowOptions.HUGIM_FLOW
    return <MultiDayConfiguration {...additional} {...props}/>
}

export const renderEditMultiDayConfig = (props) => {
    let additional = {}
    const flowName = store.getState().stepper.name
    const editType = store.getState().stepper?.editType
    let hasSchedules;
    switch (flowName) {
        case flowOptions.WORKSHOP_FLOW:
            additional.disableDate = editType === SERIES_FUTURE_SESSIONS_EDIT_TYPE
            additional.disableDays = editType === SINGLE_SESSION_EDIT_TYPE
            additional.allowDaySwitch  = editType === SERIES_FUTURE_SESSIONS_EDIT_TYPE
            additional.showLength = true
            additional.hideBlockRegistrationTime = true
            break;
        case flowOptions.HUGIM_FLOW:
            const isOneDayHug = props.target?.series?.start_date === props.target?.series?.end_date
            additional.hideBlockRegistrationTime = true
            additional.showOnlyTimeSelectors = editType === SINGLE_SESSION_EDIT_TYPE
            additional.singleDay = editType === SINGLE_SESSION_EDIT_TYPE
            additional.allowDaySwitch = editType === SERIES_FUTURE_SESSIONS_EDIT_TYPE && !isOneDayHug
            additional.allowEditDateRange = editType === SERIES_FUTURE_SESSIONS_EDIT_TYPE
            additional.showDaysEditInfoText = editType === SERIES_FUTURE_SESSIONS_EDIT_TYPE
            additional.isOneDayHug = isOneDayHug
            additional.showDayDescription = editType === SERIES_FUTURE_SESSIONS_EDIT_TYPE && !isOneDayHug
            break;
        case flowOptions.AVAILABILITY:
            hasSchedules = props.target?.hasSchedules;
            additional.disableDate = true
            additional.disableDays = false
            additional.disableLocation = editType === SERIES_FUTURE_SESSIONS_EDIT_TYPE ? hasSchedules : true // if edit all then enable only if there are no connected schedules. else (aka single edit), disable always
            additional.disableCoach = hasSchedules
            additional.allowDaySwitch = false
            additional.allowTimeExpandOnly = hasSchedules
            additional.singleDay = true
            additional.showServices = true
            additional.showLocationSelect = true
            additional.showCoachSelect = true
            additional.showSpaceSelect = false
            break;
        case flowOptions.SPACE_AVAILABILITY:
            hasSchedules = props.target?.hasSchedules;
            additional.disableDate = true
            additional.disableDays = false
            additional.disableLocation = editType === SERIES_FUTURE_SESSIONS_EDIT_TYPE ? hasSchedules : true // if edit all then enable only if there are no connected schedules. else (aka single edit), disable always
            additional.disableSpaces = hasSchedules
            additional.allowDaySwitch = false
            additional.allowTimeExpandOnly = hasSchedules
            additional.singleDay = true
            additional.showServices = true
            additional.showLocationSelect = true
            additional.showCoachSelect = false
            additional.showSpaceSelect = true
            additional.servicesTypeOverride = APPOINTMENT
            additional.disableSpace = hasSchedules
            break;
    }
    return <EditMultiDayConfig {...additional} {...props}/>
}

const renderUserAndMembershipSelection = (props) => {
    let additional = {}
    const isRepeat = props?.values?.repeatConfig?.repeat === true
    additional.oneTimeMembership = getOneTimeMembership(props.values)
    additional.showOneTimePurchase = !!(!isRepeat && additional?.oneTimeMembership)
    additional.showProTip = isBoxInTrial()
    additional.allowMultiOneTimeMembership = !!additional.oneTimeMembership && isRepeat && props?.values?.repeatConfig?.type === 'times'
    return <UserAndMembershipSelection {...additional} {...props}/>
}

const renderSpaceConfigStep = (props) => {
    return <SpaceConfiguration {...props}/>
}

const renderPaymentMethodSelection = (props) => {
    return <PaymentMethod {...props}/>
}

const renderMemberDetails= (props) => {
    return <MemberDetails {...props}/>
}

const renderStaffMemberRoleSelect= (props) => {
    return <StaffMemberRoleSelection {...props}/>
}

const renderBlockedTime= (props) => {
    return <BlockedTime {...props}/>
}

const renderMessageTypeSelect= (props) => {
    return <MessageType {...(props || {})}/>
}

const renderMessageDetails= (props) => {
    return <MessageDetails {...(props || {})}/>
}

const renderEmailAfterPurchase = (props) => {
    return <EmailAfterPurchase {...props}/>
}

const renderPenaltySettingsConfigStep = (props) => {
    return <PenaltySettings {...props}/>
}

const renderPenaltySummaryStep = (props) => {
    return <PenaltySummary {...props}/>
}

const renderPenaltyExtraPropertiesConfigStep = (props) => {
    return <PenaltyExtraProperties {...props}/>
}

const renderTaskDetailsStep = (props) => {
    return <TaskDetails {...props}/>
}

const renderTaskTypeStep = (props) => {
    return <CreateTaskType {...props}/>
}

const renderCustomFieldTypeSelection = (props) => {
    return <CustomFieldSelection {...props} />;
}

const renderCustomFieldSettings = (props) => {
    const target = props.target;
    const addons = {isTypeDisabled: !!target, currentFlows: target?.custom_field_flow}
    return <CustomFieldSettings {...props} {...addons}/>;
}

const renderSuccessStep = (props) => {
    const addonProps = getSuccessProps({...props})
    return <SuccessStep {...addonProps} {...props}/>
}

const renderSeriesPaymentOptionsStep = (props) => {
    const editType = store.getState().stepper?.editType
    let additional = {}
    additional.showEditMessage = editType !== null
    additional.isEdit = editType !== null
    additional.showTrialOption = props?.hasPermission('bookForTrialHugim') && editType !== SINGLE_SESSION_EDIT_TYPE
    additional.hasHideFullHugInSiteProp = !!props?.target?.series?.hide_full_hug_in_site_prop
    return <SeriesPaymentOptions {...additional} {...props}/>
}

const renderChoosePaymentOptionsStep = (props) => {
    const flowName = store.getState().stepper.name;
    let additional = {}
    const targetOverride = flowName === flowOptions.SWAP_HUG_REGISTRATION ? props.values : props.target;
    const selectedNumOfDays = parseInt(targetOverride.bookingType.split('_').pop(), 10)
    additional.paymentOptions = selectedNumOfDays ?
        targetOverride.eventData.series.partialBookingOptions.filter(option => ([MembershipTypes.REGULAR, MembershipTypes.RECURRING].includes(option.type) && (option.numOfDays === selectedNumOfDays)))
        :
        targetOverride.eventData.series.membership_types_all.filter(mt => [MembershipTypes.REGULAR, MembershipTypes.RECURRING].includes(mt.type) && !mt.membership_types_partial_prop)
    additional.startDate = targetOverride.eventData.date;
    additional.skipStep = flowName === flowOptions.SWAP_HUG_REGISTRATION && additional.paymentOptions.length === 1;
    return <HugPaymentsOptions {...additional} {...props}/>
}

export const getCartOverrideByFlow = (flowName, values) => {
    let cartOverride = null
    switch(flowName) {
        case flowOptions.APPOINTMENT_BASIC:
        case flowOptions.APPOINTMENT_WITH_AVAILABILITY:
        case flowOptions.APPOINTMENT_WITH_SPACE_AVAILABILITY:
            const oneTimeMembership = getOneTimeMembership(values)
            if(oneTimeMembership) {
                cartOverride = [{...oneTimeMembership, start: values?.date, end: values?.date}]
            }
            break;
    }
    return cartOverride
}

const renderPayment = (props) => {
    const flowName = store.getState().stepper.name
    const flowProps = store.getState().stepper.props
    const membership = store.getState().stepper.selectionsTree[optionalSteps.CHOOSE_HUG_PAYMENT_TYPE]
    const trialMT = props.target?.eventData?.series?.membership_types_all?.find(mt => MembershipTypes.TRIAL_CLASS === mt.type) ?? null;
    let additional = {}
    if((flowName === flowOptions.BOOK_TO_HUG_FLOW || flowName === flowOptions.BOOK_TO_HUG_CONVERT_LEAD || flowName === flowOptions.SWAP_HUG_REGISTRATION) && membership) {
        additional.cartOverride = [membership]
    } else if ((flowName === flowOptions.BOOK_TO_HUG_TRIAL || flowName === flowOptions.BOOK_TO_GROUP_CLASS_TRIAL || flowName === flowOptions.BOOK_TO_HUG_CREATE_LEAD) && trialMT) {
        additional.cartOverride = [{...trialMT, start: props.target.eventData.date}]
    } else if (flowName === flowOptions.CLOSE_MU_DEBT) {
        additional.membership_user_id = flowProps.initProps.membership_user.id
        additional.locationOverride = flowProps.initProps.membership_user.membership_types.location_box_fk
    }
    if (flowName === flowOptions.PAYMENT_FLOW || flowName === flowOptions.PAY_FOR_SLOT_GROUP_CLASS) {
        const stepperProps = store.getState().stepper.props
        if (stepperProps.cartOverride) {
            additional.cartOverride = stepperProps.cartOverride
        }
    }
    return <Payment {...additional} {...props}/>
}

const getOneTimeMembership = (values) => {
    const flowName = store.getState().stepper.name
    const selectionsTree = store.getState().stepper.selectionsTree
    const services = store.getState().schedule.eventTypes.data
    let oneTimeMembership = null;
    if(services && selectionsTree && selectionsTree[optionalSteps.APPOINTMENT_OR_AVAILABILITY_STEP]) { //TODO with eden
        oneTimeMembership = services[selectionsTree[optionalSteps.APPOINTMENT_OR_AVAILABILITY_STEP]].find(category => category.id === values?.box_category_fk)
        oneTimeMembership = oneTimeMembership?.membership_types.find(membership => membership.location_box_fk === values?.locations_box_fk)
    } else if(services && flowName === flowOptions.APPOINTMENT_WITH_AVAILABILITY) {
        oneTimeMembership = services['appointment'].find(category => category.id === values?.box_category_fk)
        oneTimeMembership = oneTimeMembership?.membership_types.find(membership => membership.location_box_fk === values?.locations_box_fk)
    }
    return oneTimeMembership
}

const renderPersonalDetails = (props) => {
    const flowName = store.getState().stepper.name
    let additional = {}
    switch (flowName) {
        case flowOptions.BOOK_TO_HUG_CREATE_LEAD:
            additional.showCreateLeadFields = true

    }
    return <PersonalDetails displayProps={additional} {...props}/>

}

const renderSendLink = (props) => {
    const flowName = store.getState().stepper.name
    let additional = {}
    additional.hideNewUsersMemberships = true
    switch (flowName) {
        case flowOptions.SEND_LINK_TO_MEMBERSHIP_FLOW:
            additional.showPushOption = props.target.user?.type === 'user' || props.target.showPushOption
            additional.showOnlyHugim = props.target.showOnlyHugim
            additional.showOnlyItems = props.target.fromLeadProfile && !additional.showOnlyHugim
            additional.hideWhatsappOption = props.target?.hideWhatsappOption
            additional.tags = [
                { id: 'first_name', label: t('firstName') },
                { id: 'last_name', label: t('lastName') },
                { id: 'membership_link', label: t('link-to-membership'), isError: true },
            ];
            additional.hideNewUsersMemberships = !props.target.hideNewUsersMemberships
            break;
        case flowOptions.CONVERT_LINK_FLOW:
            additional.hideWhatsappOption = props.target?.hideWhatsappOption
            additional.showOnlyPlanAndSessionPacks = true
            additional.membershipSelectionTooltip = true
            additional.tags = [
                { id: 'first_name', label: t('firstName') },
                { id: 'last_name', label: t('lastName') },
                { id: 'convert_link', label: t('link-to-convert'), isError: true },
            ];
            additional.hideNewUsersMemberships = false
            break;

    }
    return <SendLink displayProps={additional} {...props} />

}

const renderRequiredFieldsSettings = (props) => {
    let additional = {}
    const hasGroup = props?.hasPermission('allowRegisterGroupMember') ?? false
    additional.infoTooltip = hasGroup && props.initProps.type !== USER_SITE_FIELDS ? {member: t('groupMemberFieldsTooltip')} : null
    return <RequiredFieldsSettings {...additional} {...props}/>
}

const renderChooseGroupConnectionUser = (props) => {
    return <ChooseGroupConnectionUser {...props}/>
}

const renderGroupConnectionAddUser = (props) => {
    return <GroupConnectionAddUser {...props}/>
}

const renderSiteTrialSettings = (props) => {
    return <SiteTrialSettings {...props}/>
}

const renderGatesApplySettings = (props) => {
    return <GatesApplySettings {...props}/>
}

const renderGatesActivityHours = (props) => {
    return <GatesActivityHours {...props}/>
}

const renderSiteLeadFormSettings = (props) => {
    return <SiteLeadFormSettings {...props} />
}

const renderAdvancedSeriesSettings = (props) => {
    const editType = store.getState().stepper?.editType
    const box = store.getState().box.box;
    const isIL = box?.locations_box[0]?.country_code === 'IL';
    let additional = {}
    additional.isEdit = editType !== null
    additional.showTrialOption = props?.hasPermission('bookForTrialHugim') && editType !== SINGLE_SESSION_EDIT_TYPE
    additional.showAddonsOption = isIL && props?.hasPermission('hugimAddons') && editType !== SINGLE_SESSION_EDIT_TYPE
    additional.showHugFormOption = editType !== SINGLE_SESSION_EDIT_TYPE
    additional.numOfWeekdaysInSeries = (props?.values.days ?? props?.values.multiDayConfig.days ?? []).length
    return <AdvancedSeriesSettings {...additional} {...props}/>
}

const renderExport = (props) => {
    return <Export {...props} />
}

const renderSendInvoicesReport = (props) => {
    return <SendInvoicesReport {...props} />
}

const renderSendDoctorJournalReport = (props) => {
    return <SendDoctorJournalReport {...props} />
}

const renderNoteTemplate = (props) => {
    return <NoteTemplate {...props} />
}

const renderNote = (props) => {
    const editType = store.getState().stepper?.editType
    const flowName = store.getState().stepper.name
    const box = store.getState().box.box;
    const lang = store.getState().userSettings.lang
    const innerInitProps = store.getState().stepper?.props?.initProps
    const boxLocale = lang?.language === 'Hebrew' ? 'he' : 'en'
    const timeFormat = box ? box.locations_box[0].time_format : null
    const isSeriesEdit = editType === SERIES_FUTURE_SESSIONS_EDIT_TYPE
    const initProps = innerInitProps ?? props.initProps
    const isBlockTimeNote = flowName === flowOptions.SCHEDULE_NOTE && !initProps?.scheduleTarget?.box_categories

    let additional = {
        targetSchedule: props.target?.relatable ?? null, //for user note schedule, not for schedule note! (confusing, i know)
        hideTemplate: !!editType || (flowName === flowOptions.SCHEDULE_NOTE),
        hideScheduleSelect: initProps?.schedule_id || (flowName === flowOptions.SCHEDULE_NOTE),
        scheduleNoteLabel: (editType && initProps?.scheduleTarget && (flowName === flowOptions.SCHEDULE_NOTE)) ? `(${t(`${isSeriesEdit ? 'series' : 'schedule'}-edit-note-date`, {date: `${moment(`${initProps.scheduleTarget.date} ${initProps.scheduleTarget.time}`, `${dbDateFormat} ${dbTimeFormat}`).locale(boxLocale).format(`dddd, MMMM D, YYYY ${timeFormat}`)}`})})` : null,
        placeholder: flowName === flowOptions.SCHEDULE_NOTE ? t('add-session-note-here-placeholder') : null,
        showPin: flowName === flowOptions.USER_NOTE && hasPermissions(['pinNoteAction']),
        showOnCheckinOption: (!!editType || (flowName === flowOptions.SCHEDULE_NOTE)) && !isBlockTimeNote,
        allowTable: flowName === flowOptions.USER_NOTE
    }
    return <Note {...additional} {...props} />
}

const renderGroupDetails = (props) => {
    return <GroupDetails {...props} />
}

const renderFlowForm = (props) => {
    let additional = {}
    additional.showHugimSection = props?.hasPermission('hugim')
    return <FlowForm {...additional} {...props}/>
}

const renderSendDebtLink = (props) => {
    let additional = {}
    const fromReport = props.target?.type === 'reports'
    additional.showPushOption = props.target.user?.type === 'user' || fromReport
    additional.hideWhatsappOption = fromReport
    additional.hideMembershipSelect = true
    additional.showExpirationDatePicker = true
    const hasScheduleConnection = !!props.target?.user?.schedule_user_id
    additional.tags = [
        { id: 'first_name', label: t('firstName') },
        { id: 'last_name', label: t('lastName') },
        { id: 'membership_type', label: t('membershipType') },
        { id: 'debt_amount', label: t("debt-amount") },
    ];
    if(hasScheduleConnection) {
        additional.tags.push({ id: 'coach', label: t('coachName') })
    }
    additional.tags.push({ id: 'debt_link', label: t('link-to-debt'), isError: true })
    return <SendLink displayProps={additional} {...props} />
}

const renderSendConfirmationLink = (props) => {
    let additional = {}
    additional.showPushOption = props.target.user?.type === 'user'
    additional.hideMembershipSelect = true
    additional.tags = [
        { id: 'first_name', label: t('firstName') },
        { id: 'last_name', label: t('lastName') },
        { id: 'confirmation_link', label: t('link-to-confirmation'), isError: true },
        { id: 'date', label: t('date') },
        { id: 'day', label: t('day'), translate: true },
        { id: 'time', label: t('startTime') },
        { id: 'end_time_schedule_user', label: t('end-time') },
        { id: 'session_name', label: t('sessionName') },
        { id: 'coach', label: t('coach') },
        ...(props.hasPermission('spaces') ? [{ id: 'space', label: t('space') }] : []),
        ...(store.getState().box.box?.locations_box?.length > 1 ? [{ id: 'location', label: t('location') }] : [])
    ];
    return <SendLink displayProps={additional} {...props} />
}

const renderBuildUniformReport = (props) => {
    return <BuildUniformReport {...props}/>
}

const renderUserChargeSetting = (props) => {
    let additional = {}
    additional.paymentProvider = props.initProps?.paymentProvider
    return <UserChargeSetting {...additional} {...props}/>
}

const renderUserNoteExport = (props) => {
    let additional = {}
    let tags = [
        { id: 'first_name', label: t('firstName') },
        { id: 'last_name', label: t('lastName') },
    ];
    if(props.target.relatable_id) {
        tags.push({ id: 'date', label: t('date') })
        tags.push({ id: 'time', label: t('startTime')})
    } else {
        tags.push({ id: 'note_date', label: t('noteDate') })
        tags.push({ id: 'note_time', label: t('noteTime')})
    }
    additional.tags = tags
    return <UserNoteExport {...additional} {...props} />
}

const renderChooseHug = (props) => {
    return <ChooseHug {...props}/>
}

const renderBookingType = (props) => {
    return <BookingType {...props}/>
}

const getMultiDayConfigInitialValues = (eventDateTime, selectedDay, initProps) => {
    const flowName = store.getState().stepper.name
    const day = moment(eventDateTime?.date).day()
    switch (flowName) {
        case flowOptions.WORKSHOP_FLOW:
            return {
                start_date: eventDateTime?.date ?? moment().format(dbDateFormat),
                end_date: eventDateTime?.date ? moment(eventDateTime?.date, dbDateFormat).add(1, 'month').format(dbDateFormat) : moment().add(1, 'month').format(dbDateFormat),
                multiDayConfig: {
                    days: selectedDay ? [{day: selectedDay, start_time: eventDateTime?.start ?? '09:00:00', end_time: '17:00:00'}] : [{day: moment().day(), start_time: eventDateTime?.start ?? '09:00:00', end_time: '17:00:00'}],
                    seriesName: ''
                },
            }
        case flowOptions.HUGIM_FLOW:
            return {
                isUnlimited: false,
                isOneDay: false,
                start_date: eventDateTime?.date ?? moment().format(dbDateFormat),
                end_date: eventDateTime?.date ? moment(eventDateTime?.date, dbDateFormat).add(1, 'month').format(dbDateFormat) : moment().add(1, 'month').format(dbDateFormat),
                multiDayConfig: {
                    days: selectedDay ? [{day: selectedDay, start_time: eventDateTime?.start ?? '09:00:00', end_time: '17:00:00'}] : [{day: moment().day(), start_time: eventDateTime?.start ?? '09:00:00', end_time: '17:00:00'}],
                    seriesName: ''
                },
            }
        case flowOptions.AVAILABILITY:
            return {
                date: eventDateTime?.date ?? moment().format(dbDateFormat),
                location_fk: null,
                coach_ub_id: hasLimitedCoachViewSchedule() ? store.getState().user?.user?.id : (initProps?.coach_ub_id ?? null),
                repeat: true,
                slot_length: 15,
                break_length: 0,
                block_registration_time: 0,
                multiDayConfig: [{day: day, setting: [{start_time: '09:00:00', end_time: '17:00:00', limitations: []}]}]
            }
        case flowOptions.SPACE_AVAILABILITY:
            return {
                date: eventDateTime?.date ?? moment().format(dbDateFormat),
                location_fk: null,
                spaces_id: initProps?.spaces_id ?? null,
                repeat: true,
                slot_length: 15,
                break_length: 0,
                block_registration_time: 0,
                multiDayConfig: [{day: day, setting: [{start_time: '09:00:00', end_time: '17:00:00', limitations: []}]}]
            }
        default:
            return {}
    }
}

const getMultiDayConfigValidationSchema = () => {
    const flowName = store.getState().stepper?.name
    switch (flowName) {
        case flowOptions.WORKSHOP_FLOW:
            return getBasicWorkshopValidationSchema().shape({
                end_date: yup.string().required(t('thisFieldIsMandatory')).when(['start_date'], (start_date, schema) => {
                    const start = moment(start_date, dbDateFormat)
                    return schema.test({
                        test: end => moment(end, dbDateFormat).isAfter(start),
                        message: t('shiftTimeError')
                    })
                }).test('date-format', 'invalid date', function(value){
                    return moment(value, dbDateFormat).format(dbDateFormat) === value
                }),
            })
        case flowOptions.HUGIM_FLOW:
            return getBasicWorkshopValidationSchema().shape({
                isUnlimited: yup.boolean(),
                isOneDay: yup.boolean(),
                end_date: yup.string().when("isUnlimited", {
                    is: true,
                    then: yup.string().nullable(true).test('is-null', 'end_date must be null', value => value === null), //must be null when isUnlimited=true
                    otherwise: yup.string().required(t('thisFieldIsMandatory')).when(['start_date', 'isOneDay'], (start_date, isOneDay, schema) => {
                        const start = moment(start_date, dbDateFormat)
                        return schema.test({
                            test: end => end && (isOneDay ? moment(end, dbDateFormat).isSame(start) : moment(end, dbDateFormat).isAfter(start)),
                            message: t('shiftTimeError')
                        })
                    }).test('date-format', 'invalid date', function(value){
                        return value && (moment(value, dbDateFormat).format(dbDateFormat) === value)
                    }),
                })
            })
        case flowOptions.AVAILABILITY:
            return getAvailabilityBasicValidationSchema().shape({
                location_fk: yup.number().positive().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
                coach_ub_id: yup.number().positive().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
            })
        case flowOptions.SPACE_AVAILABILITY:
            return getAvailabilityBasicValidationSchema().shape({
                location_fk: yup.number().positive().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
                spaces_id: yup.number().positive().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
            })
        default:
            return yup.object().shape({})
    }
}

const getBasicInfoInitialValues = (target, initProps) => {
    const flowName = store.getState().stepper?.name
    const editType = store.getState().stepper?.editType
    const scheduleTarget = target
    if(editType === SERIES_FUTURE_SESSIONS_EDIT_TYPE && target.series) {
        target = target.series
    }
    let values = {
        box_category_fk: target?.box_category_fk ?? null,
        coach_fk: target?.coach_fk ?? target?.coach?.user_fk ?? initProps?.coach_fk ?? null,
        locations_box_fk: target?.locations_box_fk ?? target?.location_fk ?? null,
        spaces_id: target?.spaces_id ?? initProps?.spaces_id ?? null,
        season_id: target?.season_id ?? initProps?.season_id ?? null,
        customFields: customFieldInit(target, editType),
        scheduleTarget: scheduleTarget ?? null,
        spaces_relation: getSpacesRelationForEdit(scheduleTarget)
    }
    if (!editType && hasLimitedCoachViewSchedule()) {
        values.coach_fk = store.getState().user?.user?.user_fk;
    }
    switch (flowName) {
        case flowOptions.APPOINTMENT_BASIC:
            values.live_link = target?.live_link ?? null
            break;
        case flowOptions.APPOINTMENT_WITH_AVAILABILITY:
        case flowOptions.APPOINTMENT_WITH_SPACE_AVAILABILITY:
            values.live_link = null
            values.availability_id = target?.availability_id ?? target?.id
            values.customFields = customFieldInit(target, editType, flowOptions.APPOINTMENT_BASIC)
            values.spaces_relation = null
            break;
        default:
            values.max_users = target?.max_users ?? null
            values.second_coach_fk = target?.second_coach_fk ?? null
            break;
    }
    return values;
}

const getSpacesRelationForEdit = (target) => {
    const editType = store.getState().stepper?.editType
    if(editType === SERIES_FUTURE_SESSIONS_EDIT_TYPE) {
        console.log('here', target?.series?.spaces_relation)
        return target?.series?.spaces_relation?.length ? target.series.spaces_relation :  null
    } else if(editType === SINGLE_SESSION_EDIT_TYPE) {
        return handleEventSpacesRelation(target);
    } else return null
}

const customFieldInit = (target, editType, flowNameOverride = null, filterByCurrentLocation = false) => {
    let temp = [];
    const flowName = store.getState().stepper?.name;
    const isUserFlowType = userFlowsOnly.includes(flowName);
    const userCustomFields = filterByCurrentLocation ?
                            store.getState().schedule.userCustomFields?.filter(customField => customField.locations_box.some(location => location.id === target?.locations_box_fk)) :
                            store.getState().schedule.userCustomFields;

    const scheduleCustomFields = store.getState().schedule.scheduleCustomFields
    const customFieldByFlowType = isUserFlowType ? userCustomFields : scheduleCustomFields;
    const customFieldByFlowName = customFieldByFlowType?.filter(customField => customField.custom_field_flow.some(flowObj => flowObj.flow.name === (flowNameOverride ?? flowName)))
    const currentFields = target?.custom_field_value?.length ? target?.custom_field_value : target?.series?.custom_field_value;

    const byFlowNameFormatted = customFieldByFlowName?.map(field => ({
        ...field,
        custom_field_id: field.id,
        customFieldType: isUserFlowType ? USER_TYPE_TC : SCHEDULE_TYPE_TC, //not sure why its capitalized, not changing because im afraid to break something.
        props: field.props,
        editType: editType,
        date: target?.date,
        modelId: target?.id,
        value: field?.value,
    }));

    if(isUserFlowType) {
        //TODO (might be changed in the future)
        // in case its user type, otherwise continue to the array merge (happens just for schedule, might be changed later)
        return byFlowNameFormatted;
    }

    const currentFieldsFormatted = currentFields?.map(field => ({
            id: field.custom_field.id,
            custom_field_value_id: field.id,
            custom_field_id: field.custom_field.id,
            custom_field_name: field.custom_field.name,
            custom_field_type: field.custom_field.type,
            props: field.custom_field.props,
            customFieldType: 'Schedule', //TODO get it from somewhere
            editType: editType,
            date: target.date,
            modelId: target.id,
            value: field.value
    }));

    temp = [...currentFieldsFormatted ?? [], ...byFlowNameFormatted ?? []];
    return uniqBy(temp, 'id');
}

const getCustomFieldValueValidationSchema = () => {
    return yup.array(yup.object().shape({
        value: yup.string().nullable()
            .when('props', {
                is: value => value.isRequired,
                then: schema => schema.required(t('thisFieldIsMandatory'))
            })
            .when('custom_field_type', {
                is: value => value === 'phone',
                then: schema => schema.matches(/^(\+?\d{5,15})$/, t('non-numeric-chars')).min(5, t('phoneNumberIsTooShort', {min: 5})),
            }),
    }));
}

const getCustomFieldSettingsInitialValues = (target) => {
    const box = store.getState().box.box;
    const locationOptions =
        target?.locations_box ?
            (Array.isArray(target.locations_box) ?
                target.locations_box.map(location => ({ id: location.id, value: location.id, label: location.location })) :
                []) :
            (Array.isArray(box?.locations_box) ?
                box.locations_box.map(location => ({ id: location.id, value: location.id, label: location.location })) :
                []);
    const selectionsTree = store.getState().stepper.selectionsTree;
    const customFieldType = target?.flow_type ?? selectionsTree[optionalSteps.CUSTOM_FIELD_TYPE_SELECTION] ?? null;

    const data = {
        custom_field_id: target?.id ?? null,
        customFieldName: target?.custom_field_name ?? '',
        locations: locationOptions,
        inputType: target?.custom_field_type ?? customFieldTypes.SELECT,
        props: target?.props ?? {isRequired: true},
        flows: [],
    }
    if(customFieldType) { //in case of user funnel is selected
        return {...data, customFieldType }
    }

    return data;
}

const getExportInitialValues = () => {
    return {
        location_fk: null,
        file_type: 2,
        new_only: false,
        exclude_deposite: false,
        month: moment().month() + 1,
        year: moment().year(),
        email_to: null,
        reference_date: null,
        general_sort: 999,
        general_cust: 9999,
        include_mtc: false,
        heshing: false,
        export_to: 'movFile'
    }
}

const getSendInvoicesReportInitialValues = () => {
    const financeAccountantEmail = store.getState().userSettings.financeAccountantEmail
    const userEmail = store.getState().user.user.email

    return {
        csv: true,
        pdf: false,
        email: financeAccountantEmail || '',
        bcc: userEmail || ''
    }

}

const getExportValidationSchema = () => {
    return yup.object().shape({
        location_fk: yup.number().positive().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        file_type: yup.number().oneOf([1,2,4]).required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        new_only: yup.boolean().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        exclude_deposite: yup.boolean().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        include_mtc: yup.boolean().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        heshing: yup.boolean().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        month: yup.number().positive().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        year: yup.number().positive().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        email_to: yup.string().when('export_to', {
            is: value => value === 'email',
            then: (schema) => schema.email(t('emailIsInvalid')).test('email-domains', t('invalidEmailDomain'), function (value) {
                return !validateAfterEmailSymbol(value);
            }),
            otherwise: (schema) => schema.nullable()
        }),
        reference_date: yup.string().nullable(),
        export_to: yup.string()
    })
}

const getSendInvoicesValidationSchema = () => {
    return yup.object().shape({
        pdf: yup.boolean(),
        csv: yup.boolean().test('csv', t('select-at-least-1-export-option'), function(value){
            return this.parent.pdf || value
        }),
        email: yup.string().email(t('emailIsInvalid')).required(t('thisFieldIsMandatory')).test('email-domains', t('invalidEmailDomain'), function (value) {
            return !validateAfterEmailSymbol(value);
        }),
        bcc: yup.string().nullable().email(t('emailIsInvalid')).test('email-domains', t('invalidEmailDomain'), function (value) {
            return !value || !validateAfterEmailSymbol(value);
        })
    })
}

const getSendDoctorJournalReportValidationSchema = () => {
    return yup.object().shape({
        coach_ub_id: yup.number().positive(t('thisFieldIsMandatory')).required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        fromDate: yup.string().required(t('thisFieldIsMandatory')),
        toDate: yup.string().required(t('thisFieldIsMandatory')).test('date-range', t('date-range-error'), function (value) {
            if (!value || !this.parent.fromDate) return true;
            return moment(value, dbDateFormat).isSameOrAfter(moment(this.parent.fromDate, dbDateFormat), 'day');
        }),
        csv: yup.boolean(),
        pdf: yup.boolean().test('exportType', t('select-at-least-1-export-option'), function (value) {
            return this.parent.csv || !!value;
        }),
        primaryEmail: yup.string().email(t('emailIsInvalid')).required(t('thisFieldIsMandatory')).test('email-domains', t('invalidEmailDomain'), (value) => !validateAfterEmailSymbol(value)),
        bcc: yup.string().nullable().email(t('emailIsInvalid')).test('email-domains', t('invalidEmailDomain'), (value) => !value || !validateAfterEmailSymbol(value)),
        declarationAccepted: yup.boolean().oneOf([true], t('thisFieldIsMandatory'))
    })
}

const getSendDoctorJournalReportInitialValues = (initProps) => {
    const params = initProps?.params ?? store.getState().stepper?.props?.initProps?.params;
    const user = store.getState().user?.user;
    return {
        coach_ub_id: params?.coach_ub_id ?? null,
        fromDate: params?.fromDate ?? moment().startOf('day').format(dbDateFormat),
        toDate: params?.toDate ?? moment().endOf('day').format(dbDateFormat),
        hideClientName: false,
        csv: true,
        pdf: false,
        primaryEmail: '',
        bcc: user?.email || '',
        declarationAccepted: false
    }
}

const getBasicInfoValidationSchema = (target) => {
    const flowName = store.getState().stepper?.name
    const calendarType = store.getState().schedule?.calendarType
    const spacesRelationSchema = yup.array().nullable().of(yup.object().shape({ id: yup.number().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory'))}))

    switch (flowName) {
        case flowOptions.APPOINTMENT_BASIC:
            return yup.object().shape({
                box_category_fk: yup.number().positive().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
                coach_fk: yup.number().positive().nullable().typeError(t('thisFieldIsMandatory')),
                spaces_id: conditionalRequiredSchema(yup.number().positive().nullable().typeError(t('thisFieldIsMandatory')), calendarType === SPACES_TYPE),
                locations_box_fk: yup.number().positive().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
                live_link: yup.string().nullable(),
                customFields: getCustomFieldValueValidationSchema(target),
                spaces_relation: spacesRelationSchema
            })
        case flowOptions.APPOINTMENT_WITH_AVAILABILITY:
            return yup.object().shape({
                box_category_fk: yup.number().positive().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
                coach_fk: yup.number().positive().required(),
                locations_box_fk: yup.number().positive().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
                live_link: yup.string().nullable(),
                availability_id: yup.number().positive().required(),
                customFields: getCustomFieldValueValidationSchema(target)
            })
        case flowOptions.APPOINTMENT_WITH_SPACE_AVAILABILITY:
            return yup.object().shape({
                box_category_fk: yup.number().positive().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
                locations_box_fk: yup.number().positive().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
                spaces_id: conditionalRequiredSchema(yup.number().positive().nullable().typeError(t('thisFieldIsMandatory')), calendarType === SPACES_TYPE),
                live_link: yup.string().nullable(),
                availability_id: yup.number().positive().required(),
                customFields: getCustomFieldValueValidationSchema(target)

            })
        default:
            return yup.object().shape({
                box_category_fk: yup.number().positive().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
                coach_fk: yup.number().positive().nullable(),
                second_coach_fk: yup.number().positive().nullable(),
                locations_box_fk: yup.number().positive().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
                spaces_id: conditionalRequiredSchema(yup.number().positive().nullable().typeError(t('thisFieldIsMandatory')), calendarType === SPACES_TYPE),
                season_id: yup.number().positive().nullable().typeError(t('thisFieldIsMandatory')),
                max_users: yup.number().min(0).required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
                customFields: getCustomFieldValueValidationSchema(target),
                spaces_relation: spacesRelationSchema
            })
    }
}

const getNoteValidationSchema = () => {
    const flowName = store.getState().stepper?.name
    let basicSchema = yup.object().shape({
        id: yup.number().nullable(),
        text: yup.string().required(t('thisFieldIsMandatory')).test(
            'has-content',
            t('thisFieldIsMandatory'),
            (value) => {
                if (!value) return false;
                const textOnly = value.replace(/<[^>]*>/g, '').trim();
                return textOnly !== '';
            }
        ),
    })
    switch (flowName) {
        case flowOptions.USER_NOTE:
            return basicSchema.concat(yup.object().shape({
                message_template_id: yup.number().nullable(),
                schedule_id: yup.number().nullable(),
                users_id: yup.number().required(),
                pin: yup.boolean()
            }))
        case flowOptions.SCHEDULE_NOTE:
            return basicSchema.concat(yup.object().shape({
                schedule_id: yup.number().nullable(),
                series_id: yup.number().nullable(),
                isSingle: yup.boolean().when(['fromCreateEvent'], {
                    is: (fromCreateEvent) => fromCreateEvent === true,
                    then: yup.boolean().nullable(),
                    otherwise: yup.boolean().required()
                }),
                fromCreateEvent: yup.boolean()
            }))
        default:
            return basicSchema;
    }
}

const getNoteInitialValues = ({target, ogInitProps}) => {
    const flowName = store.getState().stepper?.name
    const editType = store.getState().stepper?.editType
    const innerInitProps = store.getState().stepper?.props?.initProps
    const initProps = innerInitProps ?? ogInitProps;

    let basic = {
        id: target?.id ?? null,
        message_template_id: target?.message_template_id ?? null,
        text: target?.text ?? '',
    }

    switch (flowName) {
        case flowOptions.USER_NOTE:
            return {...basic,
                users_id: initProps?.users_id,
                schedule_id: target?.relatable_id ?? initProps?.schedule_id ?? null,
                pin: !!target?.pin
            }
        case flowOptions.SCHEDULE_NOTE:
            if(editType) {
                return {
                    ...basic,
                    editType,
                    series_id: initProps.scheduleTarget.series_fk,
                    schedule_id: initProps.scheduleTarget.id,
                    isSingle: editType !== SERIES_FUTURE_SESSIONS_EDIT_TYPE,
                    actionType: initProps.actionType ?? 'edit',
                    check_in: initProps.scheduleTarget.scheduleNote?.check_in
                }
            } else {
                return {
                    ...basic,
                    // series_id: target?.relatable_id && target?.relatable_type?.toLowerCase().includes('series') ? target?.relatable_id : (initProps?.series_id ?? null),
                    // schedule_id: target?.relatable_id && target?.relatable_type?.toLowerCase().includes('schedule') ? target?.relatable_id : (initProps?.schedule_id ?? null),
                    series_id: initProps?.series_id ?? null,
                    schedule_id: initProps?.schedule_id ?? null,
                    isSingle: initProps?.isSingle,
                    fromCreateEvent: initProps?.fromCreateEvent,
                }
            }
        default:
            return basic;
    }
}

const getFlowFormInitialValues = ({target, ogInitProps}) => {
    const hugimFormSettings = store.getState().box.box.settings?.[HUGIM_FORM]
    const groupFormSettings = store.getState().box.box.settings?.[GROUP_FORM]
    const innerInitProps = store.getState().stepper?.props?.initProps
    const initProps = innerInitProps ?? ogInitProps;
    const existingHugimFormSetting = hugimFormSettings?.find(s => s.properties?.form_id === initProps?.form?.id)
    const existingGroupFormSetting = groupFormSettings?.find(s => s.properties?.form_id === initProps?.form?.id)

    return {
        hugimType: {
            id: existingHugimFormSetting?.id ?? null,
            form_id: initProps?.form?.id,
            hugim: existingHugimFormSetting?.properties?.hugim ?? [],
            allowTrial: existingHugimFormSetting?.properties?.allowTrial ?? false,
        },
        groupType: {
            id: existingGroupFormSetting?.id ?? null,
            form_id: initProps?.form?.id,
            box_categories: existingGroupFormSetting?.properties?.box_categories ?? [],
            allowTrial: existingGroupFormSetting?.properties?.allowTrial ?? false,
        }
    }
}

const updateSelectionTree = (dispatch) => {
    const tempSelection = store.getState().stepper.tempSelection
    if(tempSelection) dispatch(addToSelectionsTree(tempSelection))
}

const memberDetailsOnNext = (dispatch) => {
    const tempSelection = store.getState().stepper.tempSelection
    if (tempSelection) {
        dispatch(isEmailAvailable(tempSelection))
    }
}

const convertLeadOnNextStep = async (dispatch) => {
    const tempSelection = store.getState().stepper.tempSelection
    if(tempSelection) {
        dispatch(checkEmailChange({tempSelection}))
    }
}

const checkDateTimeLimitations = async (dispatch, onSave) => {
    try {
        const tempSelection = store.getState().stepper.tempSelection
        if (tempSelection?.spaces_id) {
            const res = await fetchApi('spaces/checkScheduleDateTimeOpen', 'POST', tempSelection, false, true);
            if (res.length) {
                const box = store.getState().box.box;
                const timeFormat = box ? box.locations_box[0].time_format : null
                const dateFormat = box ? box.locations_box[0].date_format : null
                let params = {
                    date: moment(tempSelection.date, dbDateFormat).format(dateFormat),
                    start_time: moment(tempSelection.start_time, dbTimeFormat).format(timeFormat),
                    end_time: moment(tempSelection.end_time, dbTimeFormat).format(timeFormat),
                }
                dispatch(openModal({modalName: STEPPER_CONFIRM_MODAL,
                    props: {
                        header: t('areYouSure'),
                        subheader: t('spaceUnavailableTimeWarning', params),
                        onConfirm: () => updateCurrentStep(dispatch, onSave)
                    }
                }))
            } else {
                updateCurrentStep(dispatch, onSave)
            }
        } else {
            updateCurrentStep(dispatch, onSave)
        }
    } catch (error) {
        console.log('error',error)
        updateCurrentStep(dispatch, onSave)
    }
}

const updateCurrentStep = (dispatch, onSave) => {
    dispatch(updateTempSelection(null))
    dispatch(closeModal({ modalName: STEPPER_CONFIRM_MODAL}));
    const flowConfig = store.getState().stepper
    const stepIndex = flowConfig.steps.indexOf(flowConfig?.currStep);
    if(flowConfig.steps[stepIndex + 1] !== optionalSteps.SUCCESS_PAGE) {
        dispatch(updateCurrStep(flowConfig.steps[stepIndex + 1]))
    } else {
        onSave()
    }
}

const getRepeatConfigValidationSchema = () => {
    const isEdit = store.getState().stepper.editType
    return yup.object().shape({
        date: yup.string().required(t('thisFieldIsMandatory')).test('date-format', 'invalid date', function(value){
            return moment(value, dbDateFormat).format(dbDateFormat) === value
        }),
        time: yup.string().required(t('thisFieldIsMandatory')).test('time-format', 'invalid time', function(value){
            return moment(value, dbTimeFormat).format(dbTimeFormat) === value
        }),
        end_time: yup.string().required(t('thisFieldIsMandatory')).when(['time'], (time, schema) => {
            const start = moment(time, dbTimeFormat)
            return schema.test({
                test: end => moment(end, dbTimeFormat).isAfter(start),
                message: t('shiftTimeError')
            })
        }).test('time-format', 'invalid time', function(value){
            return moment(value, dbTimeFormat).format(dbTimeFormat) === value
        }),
        repeatConfig: yup.object().when([], {
            is: () => isEdit === null,
            then: yup.object().shape({
                repeat: yup.boolean().required(t('thisFieldIsMandatory')),
                type: yup.string().nullable().when(['repeat'], (repeat_val, schema) => {
                    return schema.test({
                        test: type => repeat_val ? ['forever', 'until', 'times'].includes(type) : true,
                        message: 'invalid type'
                    })
                }),
                until: yup.string().nullable().when("type", {
                    is: 'times',
                    then: yup.string().required(t('thisFieldIsMandatory')).test('date-format', 'invalid date', function (value) {
                        return moment(value, dbDateFormat).format(dbDateFormat) === value
                    })
                }),
                times: yup.number().nullable().when("type", {
                    is: 'times',
                    then: yup.number().nullable().when('repeat', {
                        is: true,
                        then: yup.number(t('onlyWhole')).integer(t('onlyWhole')).required(t('thisFieldIsMandatory')).min(2, t('minimumTwoSessions')).max(104).typeError(t('thisFieldIsMandatory'))
                        .test('multi-days', t('multiDaysTimesError'), function (value) {
                            return this.parent?.type !== 'times' || this.parent?.days?.length === 1
                        }),
                    }),
                }),
                days: yup.array().of(yup.number().min(0).max(6)).min(1, t('one-day-minimum')),
                seriesName: yup.string().nullable()
            }),
            otherwise: yup.object().nullable().notRequired()
        })
    })
}

const getAvailabilityConfigValidationSchema = () => {
    const isEdit = store.getState().stepper.editType
    if(isEdit) {
        return yup.object().shape({
            date: yup.string().required(t('thisFieldIsMandatory')).test('date-format', 'invalid date', function (value) {
                return moment(value, dbDateFormat).format(dbDateFormat) === value
            }),
            time: yup.string().required(t('thisFieldIsMandatory')).test('time-format', 'invalid time', function (value) {
                return moment(value, dbTimeFormat).format(dbTimeFormat) === value
            }),
            end_time: yup.string().required(t('thisFieldIsMandatory')).when(['time'], (time, schema) => {
                const start = moment(time, dbTimeFormat)
                return schema.test({
                    test: end => moment(end, dbTimeFormat).isAfter(start),
                    message: t('shiftTimeError')
                })
            }).test('time-format', 'invalid time', function (value) {
                return moment(value, dbTimeFormat).format(dbTimeFormat) === value
            })
        })
    } else return getRepeatConfigValidationSchema()
}


const getMessageDetailsValidationSchema = () => {
    return yup.object().shape({
        class_name: yup.string().oneOf(messageAudience).required(t('thisFieldIsMandatory')),
        users: yup.array(yup.object().shape({
            user_fk: yup.number().positive(),
        })).when('class_name', {
            is: value => value === 'ReportMessage' || value === 'PrivateMessage',
            then: yup.array().test('required', t('thisFieldIsMandatory') ,(value) => value?.filter(u => u.isSelected)?.length)
        }).when(['type', 'class_name'], {
            is: (type, class_name) => type === EMAIL && class_name === 'PrivateMessage',
            then: yup.array(yup.object().test('is-email', t('user-must-have-an-email'), (value) => value.email || [1,6,8].includes(value.child)))
        }).when(['type', 'class_name'], {
            is: (type, class_name) => (type === SMS || type === WHATSAPP) && class_name === 'PrivateMessage',
            then: yup.array(yup.object().test('is-phone', t('user-must-have-a-phone-number'), (value) => value.phone || [1,6,8].includes(value.child) || value.additional_phone))
        }),
        locations_box_fk: yup.number(),
        senderID: yup.string().nullable().when('type', {
            is: EMAIL,
            then: yup.string().nullable().email(t('sender-email-is-invalid')).required(t('thisFieldIsMandatory'))
            .test('sender' ,t('sender-email-is-invalid'), (value) => !validateAfterEmailSymbol(value))
        }).when('type', {
            is: SMS,
            then: yup.string().nullable().required(t('thisFieldIsMandatory'))
            .test('sender', t('sender-is-invalid'), (value) => /^[a-zA-Z0-9]{1,11}$/g.test(value))
            .test('verified', t('sender-must-be-verified'), function (value) {
                return (this.parent.verifiedSenderID && this.parent.verifiedSenderID === value) || !/^\d+$/.test(this.parent.senderID)
            })
        }),
        verifiedSenderID: yup.string().nullable(),
        messageContent: yup.string().required(t('thisFieldIsMandatory')),
        message_array: yup.array(yup.object().shape({
            text: yup.string(),
            key: yup.string(),
            keyDB: yup.string(),
        })),
        subject: yup.string().when('type', {
            is: EMAIL,
            then: yup.string().required(t('thisFieldIsMandatory'))
        })
    })
}
const conditionalUserDetailsSchema = (schema, boxSettings, field, userType) => {
    if (userType === 'groupMember' && boxSettings?.[field]?.memberRequired) {
        return schema.test('required', t('thisFieldIsMandatory'), function (value, data) {
            return value || !data?.options?.context?.head;
        })
    }
    if (boxSettings?.[field]?.[`${userType}Required`]) {
        return schema.required(t('thisFieldIsMandatory'))
    }
    return schema
}

// userType in {'member', 'lead', 'staff_member', undefined}
const getUserDetailsBaseValidationSchema = (userType) => {
    const boxSettings = store.getState().box.box.settings?.[USER_FIELDS]
    const flowName = store.getState().stepper.name
    userType = userType || flowName?.toLowerCase();

    const commonSchema = {
        first_name: yup.string().required(t('thisFieldIsMandatory')),
        last_name: conditionalUserDetailsSchema(yup.string(), boxSettings, 'last_name', userType),
        email: conditionalUserDetailsSchema(yup.string().nullable(true).email(t('emailIsInvalid')).test('email-domains', t('invalidEmailDomain'), function (value) {
            return !validateAfterEmailSymbol(value);
        }), boxSettings, 'email', userType),
        phone: conditionalUserDetailsSchema(yup.string(), boxSettings, 'phone', userType),
        birthday: conditionalUserDetailsSchema(yup.string().nullable(true), boxSettings, 'birthday', userType),
        gender: conditionalUserDetailsSchema(yup.string().nullable(true), boxSettings, 'gender', userType),

    };
    switch (flowName) {
        case flowOptions.BOOK_TO_HUG_FLOW:
        case flowOptions.BOOK_TO_HUG_CONVERT_LEAD:
            return yup.object().shape({
                ...commonSchema,
                locations_box_fk: yup.number().required(t('thisFieldIsMandatory')),
                phone: commonSchema.phone.nullable(true).matches(/^(\+?\d{5,15})$/, t('invalid-phone'))
                .min(5, t('min-chars', {min: 5})),
                additional_phone: yup.string().nullable(true)
                .matches(/^[0-9\+\-]*$/, t('non-numeric-chars'))
                .test('phone-length', t('phone-length-limit'), val => !val || (val.length >= 5 && val.length <= 15)),
                personal_id: conditionalUserDetailsSchema(yup.string().nullable(true).matches(/^[0-9]*$/, t('numbers-only')).test('length-test', t('personal-id-length-error'), val => {
                    let id = String(val).trim();
                    if(val === null || val === '') return true
                    return !(id.length > 9 || id.length < 5);
                }), boxSettings, 'personal_id', userType),
                emailValidated: yup.boolean().when('email', {
                    is: value => value !== '' && value !== null,
                    then: yup.boolean().required().oneOf([true]),
                    otherwise: yup.boolean().nullable(true)
                }),
                personalIdValidated: yup.boolean().when('personal_id', {
                    is: value => value !== '' && value !== null,
                    then: yup.boolean().required().oneOf([true]),
                    otherwise: yup.boolean().nullable(true)
                }),
                phoneValidated: yup.boolean().when('phone', {
                    is: value => value !== '' && value !== null,
                    then: yup.boolean().required().oneOf([true]),
                    otherwise: yup.boolean().nullable(true)
                }),
                rfid: yup.number().nullable(true),
                invoice_name: yup.string().nullable(true).max(30, t('max-chars', {max: 30})),
                allow_mailing_list: yup.string().oneOf(['yes','no', 'unknown', 'unsubscribe']),
                allow_sms: yup.string().oneOf(['yes','no', 'unknown', 'unsubscribe']),
                customFields: getCustomFieldValueValidationSchema(),
                ...(flowName === flowOptions.BOOK_TO_HUG_CONVERT_LEAD && {lead_id: yup.number().required()})

            })
        case flowOptions.BOOK_TO_HUG_CREATE_LEAD:
            return yup.object().shape({
                ...commonSchema,
                locations_box_fk: yup.number().required(t('thisFieldIsMandatory')),
                phone: commonSchema.phone.nullable(true).matches(/^(\+?\d{5,15})$/, t('invalid-phone'))
                    .min(5, t('min-chars', {min: 5})),
                emailValidated: yup.boolean().when('email', {
                    is: value => value !== '' && value !== null,
                    then: yup.boolean().required().oneOf([true]),
                    otherwise: yup.boolean().nullable(true)
                }),
                phoneValidated: yup.boolean().when('phone', {
                    is: value => value !== '' && value !== null,
                    then: yup.boolean().required().oneOf([true]),
                    otherwise: yup.boolean().nullable(true)
                }),
                additional_phone: yup.string().nullable(true)
                .matches(/^[0-9\+\-]*$/, t('non-numeric-chars'))
                .test('phone-length', t('phone-length-limit'), val => !val || (val.length >= 5 && val.length <= 15)),
                status_fk: yup.number().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
                source_fk: conditionalUserDetailsSchema(yup.number().nullable(true), boxSettings, 'source_fk', userType),
                users_boxes_owner_id: conditionalUserDetailsSchema(yup.number().nullable(true), boxSettings, 'users_boxes_owner_id', userType),
                invoice_name: yup.string().nullable(true).max(30, t('max-chars', {max: 30})),
                comment: yup.string().nullable(true),
                allow_mailing_list: yup.string().oneOf(['yes','no', 'unknown', 'unsubscribe']),
                allow_sms: yup.string().oneOf(['yes','no', 'unknown', 'unsubscribe']),
                customFields: getCustomFieldValueValidationSchema()
            })
        case flowOptions.LEAD:
            return yup.object().shape({
                ...commonSchema,
                locations_box_fk: yup.number().required(t('thisFieldIsMandatory')),
                status_fk: yup.number().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
                source_fk: conditionalUserDetailsSchema(yup.number().nullable(true), boxSettings, 'source_fk', userType),
                users_boxes_owner_id: conditionalUserDetailsSchema(yup.number().nullable(true), boxSettings, 'users_boxes_owner_id', userType),
                city: conditionalUserDetailsSchema(yup.string(), boxSettings, 'city', userType),
                address: conditionalUserDetailsSchema(yup.string(), boxSettings, 'address', userType),
                allow_mailing_list: yup.string().oneOf(['yes','no', 'unknown', 'unsubscribe']),
                allow_sms: yup.string().oneOf(['yes','no', 'unknown', 'unsubscribe']),
                comment: yup.string().nullable(true),
                additional_phone: yup.string().nullable(true)
                .matches(/^[0-9\+\-]*$/, t('non-numeric-chars'))
                .test('phone-length', t('phone-length-limit'), val => !val || (val.length >= 5 && val.length <= 15)),
                customFields: getCustomFieldValueValidationSchema()
            })
        case flowOptions.STAFF_MEMBER:
            return yup.object().shape({
                ...commonSchema,
                locations_box_fk: yup.number().required(t('thisFieldIsMandatory')),
                personal_id: yup.string(),
                additional_phone: yup.string().nullable(true),
                properties: yup.object().shape({
                    voice_center: yup.object().shape({
                        phone: yup.string().nullable(true)
                    }),
                    employee: yup.object().shape({
                        license_id: yup.string().nullable(true).matches(/^[0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/, t('non-numeric-chars'))
                    })
                })
            })
        case flowOptions.CONNECT_USER_TO_GROUP:
            return yup.object().shape({
                ...commonSchema,
                last_name: yup.string().required(t('thisFieldIsMandatory')),
                personal_id: conditionalUserDetailsSchema(yup.string().nullable(true)),
                allow_mailing_list: yup.string().oneOf(['yes','no', 'unknown', 'unsubscribe']),
                allow_sms: yup.string().oneOf(['yes','no', 'unknown', 'unsubscribe']),
            })
        default:
            return yup.object().shape(commonSchema)
    }
}

const courseChildDetailsValidationSchema = () => {
    return yup.object().shape({
        first_name: yup.string().required(t('thisFieldIsMandatory')),
        last_name: yup.string().required(t('thisFieldIsMandatory')),

        locations_box_fk: yup.number().required(t('thisFieldIsMandatory')),
        phone: yup.string().nullable(true).matches(/^(\+?\d{5,15})$/, t('invalid-phone'))
            .min(5, t('min-chars', {min: 5})),
        email: yup.string().nullable(true).email(t('emailIsInvalid')).test('email-domains', t('invalidEmailDomain'), function (value) {
            return !validateAfterEmailSymbol(value);
        }),
        birthday: yup.string().nullable(true),
        gender: yup.string().nullable(true),
        personal_id: yup.string().nullable(true).matches(/^[0-9]*$/, t('numbers-only')).test('length-test', t('personal-id-length-error'), val => {
            let id = String(val).trim();
            if(val === null || val === '') return true
            return !(id.length > 9 || id.length < 5);
        }),
        emailValidated: yup.boolean().when('email', {
            is: value => value !== '' && value !== null,
            then: yup.boolean().required().oneOf([true]),
            otherwise: yup.boolean().nullable(true)
        }),
        personalIdValidated: yup.boolean().when('personal_id', {
            is: value => value !== '' && value !== null,
            then: yup.boolean().required().oneOf([true]),
            otherwise: yup.boolean().nullable(true)
        }),
        phoneValidated: yup.boolean().when('phone', {
            is: value => value !== '' && value !== null,
            then: yup.boolean().required().oneOf([true]),
            otherwise: yup.boolean().nullable(true)
        }),
        rfid: yup.number().nullable(true),
        invoice_name: yup.string().nullable(true).max(30, t('max-chars', {max: 30})),
        allow_mailing_list: yup.string().oneOf(['yes','no', 'unknown', 'unsubscribe']),
        allow_sms: yup.string().oneOf(['yes','no', 'unknown', 'unsubscribe']),
        customFields: getCustomFieldValueValidationSchema(),
    })
}

const getRequiredFieldsSettingsValidationSchema = () => {
    const flowConfig = store.getState().stepper
    const type = flowConfig.props?.initProps?.type
    if (!type || !boxSettingsProps[type]) return null;
    return yup.object().shape({
        properties: yup.object().shape({
            ...boxSettingsProps[type].fields.reduce((accField, currField) => ({
                ...accField,
                [currField]: yup.object().shape({
                    ...boxSettingsProps[type].flows.reduce((accFlow, currFlow) => ({
                        ...accFlow,
                        [`${currFlow}Required`]: yup.boolean()
                    }), {})
                })
            }), {})
        })
    })
}

const getUserChargeSettingValidationSchema = () => {
    const flowConfig = store.getState().stepper
    const paymentProvider = flowConfig.props?.initProps?.paymentProvider
    if(!paymentProvider) return yup.object().shape({})
    return yup.object().shape({
        properties: yup.object().shape({
            ...siteChargeOptions[paymentProvider].reduce((acc,charge) => (
                {
                    ...acc,
                    [charge]: yup.object().shape({
                        site: yup.boolean(),
                        app: yup.boolean()
                    })
                }), {})
        })
    })
}

const getUserNoteExportValidationSchema = () => {
    return yup.object().shape({
        subject: yup.string().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        message_content: yup.string().required(t('thisFieldIsMandatory')),
        email_to: yup.string().required(t('thisFieldIsMandatory')).email(t('emailIsInvalid')).test('email-domains', t('invalidEmailDomain'), function (value) {
            return !validateAfterEmailSymbol(value);
        }),
        note_relation_id: yup.number().required(),
    })
}

const siteLeadFormSettingsValidationSchema = () => {
    let validationSchema = {}
    siteFormLeadFieldOptions.forEach((field) => {
        validationSchema[field] = yup.object().shape({
            required: yup.boolean()
        })
    })
    return yup.object().shape({
        status_id: yup.number().nullable().typeError(t('thisFieldIsMandatory')),
        source_id: yup.number().nullable().typeError(t('thisFieldIsMandatory')),
        show_in_site: yup.boolean().typeError(t('thisFieldIsMandatory')),
        ...validationSchema

    })
}

const getSendMembershipLinkValidationSchema = () => {
    return getGeneralLinkValidationSchema().concat(yup.object().shape({
        available_on_app: yup.boolean().required(t('thisFieldIsMandatory')),
        item_id: yup.number().positive().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        item_type: yup.string().nullable(),
        message_content: yup.string().required(t('thisFieldIsMandatory'))
            .test('link-required', t('link-is-required'), function (value) {
                return this.parent.message_content?.includes(`[${t('link-to-membership')}]`)
            }),
    }))
}

const getGeneralLinkValidationSchema = () => {
    return yup.object().shape({
        user_fk: yup.number().when('type', {
            is: undefined,
            then: yup.number().required(t('thisFieldIsMandatory')).test('user_has_phone_email', t('user-must-have-a-phone-number-and-email'), function (value) {
                return (this.parent.send_whatsapp || this.parent.send_sms) && this.parent.send_email ? this.parent.phone && this.parent.email : true
            }).test('user_has_phone', t('user-must-have-a-phone-number'), function (value) {
                return (this.parent.send_whatsapp || this.parent.send_sms) ? this.parent.phone : true
            }).test('user_has_email', t('user-must-have-an-email'), function (value) {
                return (this.parent.send_email) ? this.parent.email : true
            }),
            otherwise: yup.number().nullable()
        }),
        send_push: yup.boolean(),
        send_email: yup.boolean(),
        send_sms: yup.boolean().test('send_sms', t('select-at-least-1'), function(value){
            return this.parent.send_email || this.parent.send_whatsapp || this.parent.send_push || value
        }),
        send_whatsapp: yup.boolean(),
        subject: yup.string().when('send_email', {
            is: true,
            then: yup.string().required(t('thisFieldIsMandatory'))
        }).typeError(t('thisFieldIsMandatory')),
        message_content: yup.string().required(t('thisFieldIsMandatory'))
    })
}

const getDebtLinkValidationSchema = () => {
    return getGeneralLinkValidationSchema().concat(yup.object().shape({
        expiration_date: yup.string().required(t('thisFieldIsMandatory')).test('date-format', 'invalid date', function (value) {
            return moment(value, dbDateFormat).format(dbDateFormat) === value
        }),
        message_template_id: yup.number().nullable(),
        membership_user_id: yup.mixed().when('type', {
            is: 'reports',
            then: yup.array().of(yup.object().shape({ id: yup.number()})).required(t('thisFieldIsMandatory')).min(1, t('min-1-membership-debt-selection')),
            otherwise: yup.number().required(t('thisFieldIsMandatory'))
        }),
        schedule_user_id: yup.number().nullable(),
        message_content: yup.string().required(t('thisFieldIsMandatory'))
            .test('link-required', t('link-is-required'), function (value) {
                return this.parent.message_content?.includes(`[${t('link-to-debt')}]`)
            }),
    }))
}

const getConfirmationLinkValidationSchema = () => {
    return getGeneralLinkValidationSchema().concat(yup.object().shape({
        message_template_id: yup.number().nullable(),
        schedule_user_id: yup.number().required(t('thisFieldIsMandatory')),
        message_content: yup.string().required(t('thisFieldIsMandatory'))
            .test('link-required', t('link-is-required'), function (value) {
                return this.parent.message_content?.includes(`[${t('link-to-confirmation')}]`)
            }),
    }))

}

const getGroupConnectionAddUserValidationSchema = () => {
    const selection = store.getState().stepper?.flags?.selection
    return yup.object().shape({
        ...(selection === 'new' ? {
            newUser: getUserDetailsBaseValidationSchema('groupMember')
        } : {
            users_boxes_id:  yup.number().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory'))
                .test('ub-not-in-group', t('user-is-already-in-a-group'), function (value) {
                    return !this.parent.groups_ub_ids.includes(value) && !this.parent.ugc_id;
                })
        }),
        child: yup.number().required(t('thisFieldIsMandatory')).oneOf(familyArray).typeError(t('thisFieldIsMandatory')),
        head: yup.boolean()
    })
}

const getBlockedTimeValidationSchema = () => {
    const calendarType = store.getState().schedule?.calendarType
    return yup.object().shape({
        coach_fk: yup.number().positive().nullable().typeError(t('thisFieldIsMandatory')),
        locations_box_fk: yup.number().positive().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        place: yup.string().typeError(t('thisFieldIsMandatory')),
        spaces_id: conditionalRequiredSchema(yup.number().positive().nullable().typeError(t('thisFieldIsMandatory')), calendarType === SPACES_TYPE),
    }).concat(getRepeatConfigValidationSchema());
}

const getRepeatInitialValues = (target, eventDateTime, selectedTime, selectedDay, flowName) => {
    if(target) { //for group session only, for now
        return {
            date: target.date,
            time: moment(target.time, 'HH:mm').format(dbTimeFormat),
            end_time: moment(target.end_time, 'HH:mm').format(dbTimeFormat),
            repeatConfig: null
        }
    }
    return {
        date: eventDateTime?.date ?? moment().format(dbDateFormat),
        time: selectedTime,
        end_time: eventDateTime?.end ?? moment(selectedTime, dbTimeFormat).add(1, 'h').format(dbTimeFormat),
        repeatConfig: {
            repeat: ![flowOptions.APPOINTMENT_BASIC, flowOptions.BLOCKED_TIME].includes(flowName),
            type: flowName !== flowOptions.APPOINTMENT_BASIC ? 'forever' : 'times',
            until: null,
            times: flowName === flowOptions.APPOINTMENT_BASIC ? 2 : 1,
            days: [selectedDay],
            seriesName: null
        }
    }
}

const getAvailabilityConfigInitialValues = (target, eventDateTime, selectedDay) => {
    const isEdit = store.getState().stepper.editType
    let vals = {
        date: isEdit ? target?.date : (eventDateTime?.date ?? moment().format(dbDateFormat)),
        time: null,
        end_time: null,
    }
    if(!isEdit) {
        vals.repeatConfig = {
            repeat: false,
            type: null,
            until: null,
            times: null,
            days: [selectedDay],
            seriesName: null
        }
    }
    return vals
}

const getSettingsInitialValues = (target = null) => {
    const isEdit = store.getState().stepper.editType
    const flowName = store.getState().stepper.name
    if(isEdit && target) {
        let params = {
            transparent: !!target.transparent,
            disable_cancellation_time: target.disable_cancellation_time ?? 0,
            enable_late_cancellation: !!target.enable_late_cancellation,
            enable_registration_time: target.enable_registration_time ?? 0,
            block_registration_time: target.block_registration_time ?? 0,
            has_spots: target.has_spots ?? 0,
            cancel_limit: target.cancel_limit,
            min_users: target.min_users,
            live_link: target.live_link,
            register_group_member: !!target.series?.register_group_member,
            allow_mid_booking: !!target.series?.allow_mid_booking
        }
        if(isEdit === SERIES_FUTURE_SESSIONS_EDIT_TYPE && target.series) {
            params.series_name = target.series.series_name
            if (flowName === flowOptions.GROUP_CLASS_FLOW) {
                params.paymentOptions = getPaymentOptionsValue(target)
            }
        }
        return params
    } else {
        return {
            transparent: [flowOptions.WORKSHOP_FLOW, flowOptions.HUGIM_FLOW].includes(flowName),
            disable_cancellation_time: 0,
            enable_late_cancellation: false,
            enable_registration_time: 0,
            block_registration_time: 0,
            cancel_limit: 0,
            has_spots: 0,
            min_users: 0,
            live_link: null,
            register_group_member: false,
            allow_mid_booking: false
        }
    }
}

const getPaymentOptionsValue = (target) => {
    const trialMembership = target.series?.membership_types_all?.find(mt => mt.type === MembershipTypes.TRIAL_CLASS);
    return trialMembership ? [{...trialMembership, type: seriesPaymentDBTranslate[trialMembership.type],
        taxes: trialMembership.membership_types_taxes.map(membershipTax => membershipTax.taxes_id) ?? [],
        paid: trialMembership.price > 0}] : [{type: TRIAL, show_in_app: 0, price: 0, max_installments: 1, taxes: [], paid: false}]
}

const getEditMultiDaysInitialValues = (eventDateTime, target) => {
    const flowName = store.getState().stepper.name
    const editType = store.getState().stepper.editType
    if(!editType) return {}

    switch (flowName) {
        case flowOptions.WORKSHOP_FLOW:
            return {
                date: target.date,
                days: target.series.series_events?.reduce((acc,e) => [...acc, {
                    start_time: e.start,
                    end_time: e.end,
                    day_of_week: e.day_of_week,
                    id: e.id
                }],[])
            }
        case flowOptions.HUGIM_FLOW:
            if(editType === SERIES_FUTURE_SESSIONS_EDIT_TYPE) {
                return {
                    isUnlimited: target.series.end_date === null,
                    isOneDay: target.series.end_date === target.series.start_date,
                    date: target.date,
                    start_date: moment(target.series.start_date, dbDateFormat).format(dbDateFormat),
                    end_date: target.series.end_date ? moment(target.series.end_date, dbDateFormat).format(dbDateFormat) : null,
                    days: target.series.series_events?.reduce((acc,e) => [...acc, {
                        start_time: e.start,
                        end_time: e.end,
                        day_of_week: e.day_of_week,
                        id: e.id,
                        description: e.description
                    }],[])
                }
            } else {
                return {
                    date: target.date,
                    start_time: moment(target.time, dbTimeFormat).format(dbTimeFormat),
                    end_time: moment(target.end_time, dbTimeFormat).format(dbTimeFormat)
                }
            }
        case flowOptions.AVAILABILITY:
        case flowOptions.SPACE_AVAILABILITY:
            return {
                date: eventDateTime?.date,
                location_fk: target.location_fk,
                coach_ub_id: hasLimitedCoachViewSchedule() ? store.getState().user?.user?.id : target.coach_ub_id,
                spaces_id: target.spaces_id,
                repeat: target.repeat,
                slot_length: target.slot_length,
                break_length: target.break_length,
                block_registration_time: target.block_registration_time ?? 0,
                start_time: target.start_time,
                end_time: target.end_time,
                day_of_week: moment(target.date, dbDateFormat).day(),
                limitations: target.availability_limitations.map(item => item.category_type_id),
            }
        default:
            return {}
    }
}

const getUserDetailsBaseInitialValues = (target, isChild = false, isParent = false) => {
    const customFieldFlowName = isChild ? 'HUG_CHILD' : (isParent ? 'HUG_PARENT' : null)
    const currTarget = target?.user || target
    const flowName = store.getState().stepper.name;
    const defaultLocation = store.getState().user.user.locations_box_fk
    const editType = store.getState().stepper?.editType
    const defaults = store.getState().box.box.settings?.[DEFAULTS]

    const commonValues = {
        first_name: currTarget?.firstName || '',
        last_name: currTarget?.lastName || '',
        email: currTarget?.email || '',
        phone: currTarget?.phone || '',
        additional_phone: currTarget?.additional_phone || null,
        birthday: currTarget?.birthday ||  null,
        gender: currTarget?.gender || '',
        locations_box_fk: currTarget?.locationBoxFk || defaultLocation || '',
    }

    switch (flowName) {
        case flowOptions.LEAD:
            return {
                ...commonValues,
                allow_sms: currTarget?.allow_sms || 'yes',
                allow_mailing_list: currTarget?.allow_mailing_list || 'yes',
                status_fk: defaults?.lead_status_id || null,
                source_fk: currTarget?.source || defaults?.source_id || null,
                users_boxes_owner_id: currTarget?.users_boxes_owner_id || null,
                city: currTarget?.city || '',
                address: currTarget?.address || '',
                updatedUser: currTarget?.id && {
                    id: currTarget?.id || null,
                    convertMemberToLead: currTarget?.id ? currTarget?.action !== 'update' : false
                }
            }
        case flowOptions.STAFF_MEMBER:
            return {
                ...commonValues,
                personal_id: currTarget?.personal_id || '',
            }
        case flowOptions.BOOK_TO_HUG_FLOW:
        case flowOptions.BOOK_TO_HUG_CONVERT_LEAD:
            return {
                ...commonValues,
                lead_id: currTarget?.user_fk || null,
                email: currTarget?.email || null,
                emailValidated: null,
                personal_id: currTarget?.personal_id || null,
                phone: currTarget?.phone || null,
                personalIdValidated: null,
                phoneValidated: null,
                additional_phone: currTarget?.additional_phone || null,
                rfid: currTarget?.rfid || null,
                invoice_name: currTarget?.invoice_name || null,
                allow_mailing_list: currTarget?.allow_mailing_list || 'yes',
                allow_sms: currTarget?.allow_sms || 'yes',
                locations_box_fk: target?.eventData?.series?.locations_box_fk,
                customFields: customFieldInit(target?.eventData, editType, customFieldFlowName, true)
            }
        case flowOptions.BOOK_TO_HUG_CREATE_LEAD:
            return {
                ...commonValues,
                allow_sms: currTarget?.allow_sms || 'yes',
                allow_mailing_list: currTarget?.allow_mailing_list || 'yes',
                status_fk: defaults?.lead_status_id || null,
                source_fk: currTarget?.source || defaults?.source_id || null,
                users_boxes_owner_id: currTarget?.users_boxes_owner_id || null,
                phone: currTarget?.phone || null,
                email: currTarget?.email || null,
                emailValidated: null,
                phoneValidated: null,
                customFields: customFieldInit(target?.eventData, editType, flowOptions.BOOK_TO_HUG_CREATE_LEAD, true),
                locations_box_fk: target?.eventData?.series?.locations_box_fk

            }
        case flowOptions.CONNECT_USER_TO_GROUP:
            return {
                ...commonValues,
                allow_mailing_list: 'yes',
                allow_sms: 'yes',
                personal_id: null,
            }

        default:
            return commonValues;
    }
}

const getEmailAfterPurchaseInitialValues = (target) => {
    return {
        membership_types: target?.auto_actions_set_membership_types?.map?.(mt => ({...mt, value: mt.membership_types_id, id: mt.membership_types_id,})) ?? [],
        users_boxes: JSON.parse(target?.auto_actions_set_triggers?.properties || null)?.notify_list?.find?.(l => l.locations_box_id === target?.locations_box_fk)?.users_boxes?.map?.(id => ({id, value: id})) ?? [],
        locations_box_id: target?.locations_box_fk,
        trial_class: JSON.parse(target?.auto_actions_set_triggers?.properties || null)?.notify_list?.find?.(l => l.locations_box_id === target?.locations_box_fk)?.trial_class || false
    }
}

const getPenaltySettingsInitialValues = (target) => {
    return {
        name: target?.name || '',
        start_date: target?.start_date || moment().format(dbDateFormat),
        trigger_occurrence_count: target?.trigger_occurrence_count || 1,
        trigger_period_count: target?.trigger_period_count || 1,
        late_cancellation: target?.late_cancellation ?? true,
        check_in: target?.check_in ?? true,
        type: target?.type || 'block_app_cancel',
        reduction: target?.type_value || 1,
        block_app_cancel: target?.type_value || 1,
        block_app_no_cancel: target?.type_value || 1,
        block_book_cancel: target?.type_value || 1,
        block_book_no_cancel: target?.type_value || 1,
        no_block_cancel: target?.type_value || 1,
        time_after_class: target?.time_after_class ||  1,
        ...(target ? getPenaltyExtraPropertiesInitialValues(target) : {}),
        ...(target ? {id: target.id, message_template_id: target.message_template_id} : {})
    }
}

const getPenaltyExtraPropertiesInitialValues = (target) => {
    let message = target?.message_template?.text || '';
    const tags = getPenaltiesTags(target?.type)
    tags.forEach(tag => {
        message = message.replaceAll(`{{#${tag.id}#}}`, `[${tag.label}]`)
    });
    return {
        membership_types: target?.membership_types?.map(mt => ({id: mt.membership_types_id, value: mt.membership_types_id})) || [],
        send_push: target?.send_push ?? true,
        send_email: target?.send_email ?? false,
        send_sms: target?.send_sms ?? false,
        send_whatsapp: target?.send_whatsapp ?? false,
        free_space: target?.free_space ||  1,
        allow_free_space: !!(target?.free_space ||  0),
        properties: {...target?.properties || {}, exclude: {
            box_categories: target?.properties?.exclude?.box_categories.map(id => ({id, value: id})) || []
        }},
        exclude: target?.properties?.exclude?.box_categories?.length || false,
        message_content: message
    }
}

const getTaskDetailsInitialValues = (target) => {
    const user = store.getState().user.user
    return {
        id: target?.id,
        reminder_time: target?.reminder_time || null,
        user_fk: target?.user_fk || null,
        task_type_fk: target?.task_type_fk || null,
        assigned_to: target ? target?.assigned_to : user.user_fk,
        description: target?.description || '',
        locations_box_fk: target?.locations_box_fk || user.locations_box_fk,
        done: target?.done || 0,
        is_personal: target?.targeted === 'personal' ? 1 : 0,
        targeted: target?.is_personal ? targetAudienceTasks.PERSONAL : (target ? target.targeted : targetAudienceTasks.SPECIFIC_USER),
        task_owner_user_fk: target?.task_owner_user_fk || null,
        check_in: target?.check_in || false,
        access_control: target?.access_control || false,
        reports_users: target?.targeted === 'reports' && Object.keys(target.selectedUsers),
        is_done_button_click: false,
        user: target?.user ? {label: target?.user.full_name, value: target?.user_fk, type: getTypeByRole(target?.user?.role?.role), ...target?.user} : null
    };
}

const getSendConvertLinkInitialValues = (target) => {
    return {
        user_fk: target?.user?.user_fk || null,
        phone: target?.user?.phone || null,
        email: target?.user?.email || null,
        full_name: target?.user?.full_name || null,
        available_on_app: true,
        send_sms: true,
        send_email: false,
        send_whatsapp: false,
        subject: '',
        message_content: '',
        type: target?.type

    };
}

const getSeriesPaymentOptionsInitialValues = (target) => {
    const editType = store.getState().stepper.editType
    if(editType) {
        const fullHugMemberships = target?.series?.membership_types_all?.filter(mt => !mt.membership_types_partial_prop)
        return {
            paymentOptions: fullHugMemberships?.map(mt => ({...mt,
                sort_code: mt.sort_code_number,
                type: seriesPaymentDBTranslate[mt.type],
                taxes: mt.membership_types_taxes.map(membershipTax => membershipTax.taxes_id) ?? [],
                addons: mt.addons?.map(addon => addon.id) ?? []
            })),
            sort_code: fullHugMemberships?.find(mt => mt.sort_code_number)?.sort_code_number || null
        }
    } else {
        return {paymentOptions: [], sort_code: null, hideFullHugInSite: false}
    }
}

const getSeriesPartialOptionsInitialValues = (target) => {
    const editType = store.getState().stepper.editType
    const hugimFormSettings = store.getState().box.box.settings?.[HUGIM_FORM]
    const existingSetting = target?.series_fk ? hugimFormSettings?.find(s => s.properties?.hugim.includes(target?.series_fk)) : null;
    const form_id = existingSetting?.properties?.form_id ?? null;

    if(editType) {
        const partialHugMemberships = target?.series?.membership_types_all?.filter(mt => mt.membership_types_partial_prop)
        const res = {
            partialOptions: partialHugMemberships?.map(mt => ({...mt,
                daysOfWeek: mt.membership_types_partial_prop.frequency,
                sort_code: mt.sort_code_number,
                type: seriesPaymentDBTranslate[mt.type],
                taxes: mt.membership_types_taxes.map(membershipTax => membershipTax.taxes_id) ?? [],
                addons: mt.addons?.map(addon => addon.id) ?? []
            })),
            form_id
        }
        return res;
    } else {
        return {partialOptions: [], form_id}
    }
}


const getRequiredFieldsSettingsInitialValues = (initProps) => {
    const type = initProps?.type ?? USER_FIELDS;
    const boxSettings = store.getState().box.box.settings?.[type]
    if (boxSettings) return {properties: boxSettings, prop_name: type};
    let initialProps = {};
    if (!boxSettingsProps[type]) return null;
    boxSettingsProps[type].fields.forEach(prop => {
        initialProps[prop] = getSettingsObjectByType(prop, boxSettingsProps[type].flows, type)
    });
    return {properties: initialProps, prop_name: type};
}

const getUserChargeSettingInitialValues = (initProps) => {
    const paymentProvider = initProps?.paymentProvider
    if(!paymentProvider) return null
    let initialProps = {};
    const boxSettings = store.getState().box.box.settings?.[CHARGE_SETTING]
    if (boxSettings) return {properties: boxSettings, prop_name: CHARGE_SETTING};
    siteChargeOptions[paymentProvider].forEach(prop => {
        initialProps[prop] = {site: prop === 'card', app: false}
    })
    return {properties: initialProps, prop_name: CHARGE_SETTING};
}

const getSiteTrialSettingsInitialValues = () => {
    const siteTrialSettings = store.getState().box.box.settings?.[SITE_TRIAL_SETTINGS]
    if(siteTrialSettings) return siteTrialSettings
    else {
        return {
            newLead: {status_id: createdStatusId, source_id: null},
            existingLead: {status_id: null, source_id: null}
        }
    }
}

const getGatesActivityHoursInitialValues = () => {
    const gates = store.getState().box.box.locations_box?.map(location => location.gates).flat().filter(gate => !gate.is_exit);
    const isOne = gates.length === 1
    return {
        gates: gates.map(gate => ({
            id: gate.id,
            name: gate.name,
            locations_box_id: gate.locations_box_id,
            multiDayConfig: activityHoursToMultiDayConfig(gate.properties?.ACTIVITY_HOURS)
        })),
        multiDayConfig: isOne ? activityHoursToMultiDayConfig(gates[0].properties?.ACTIVITY_HOURS) : []
    };
}

const activityHoursToMultiDayConfig = (activityHours) => {
    let multiDayConfig = [];
    if (activityHours) {
        let index = null;
        for (const [key, value] of Object.entries(activityHours)) {
            index = daysEnum.findIndex(day => day === key);
            if (value !== 'closed' && value) {
                multiDayConfig.push({
                    day: index,
                    setting: value?.map(([start_time, end_time]) => ({start_time, end_time}))
                })
            }
        }
    }
    return multiDayConfig;
}

const getLeadFormSiteSettingsInitialValues = () => {
    const siteLeadFormSettings =  store.getState().box.box.settings?.[SITE_LEAD_FORM_SETTINGS]
    if(siteLeadFormSettings) return siteLeadFormSettings
    let initialProps = {};
    siteFormLeadFieldOptions.forEach(prop => {
        initialProps[prop] = {required: true};
    });
    return {
        status_id: createdStatusId,
        source_id: null,
        show_on_site: false,
        ...initialProps
    }

}

const getCreateTaskTypeInitialValues = (target) => {
    return {
        task_type_color: target?.task_type_color || '#D0FFF9',
        type: target?.type || '',
        check_in: target?.check_in || false,
        access_control: target?.access_control || false,
        id: target?.task_type_id

    };
}

const getSendMembershipLinkInitialValues = (target) => {
    return {
        user_fk: target?.user?.user_fk || null,
        phone: target?.user?.phone || null,
        email: target?.user?.email || null,
        full_name: target?.user?.full_name || null,
        available_on_app: true,
        item_id: null,
        send_push: target?.user?.type === 'user',
        send_sms: target?.user?.type === 'lead',
        send_email: false,
        send_whatsapp: false,
        subject: '',
        message_content: '',
        type: target?.type
    };

}

const getDebtLinkInitialValues = ({target, initProps}) => {
    const isReport = target?.type === 'reports'
    let membership_user_id = target?.user?.membership_user_fk
    if(isReport) {
        membership_user_id = Object.values(target.selectedUsers).reduce((acc, mtArray) => [...acc, ...mtArray], [])
    }
    return {
        user_fk: target?.user?.user_fk,
        phone: target?.user?.phone || null,
        email: target?.user?.email || null,
        full_name: target?.user?.full_name || null,
        send_push: false,
        send_sms: true,
        send_email: false,
        send_whatsapp: false,
        subject: '',
        message_content: '',
        message_template_id: null,
        membership_user_id: membership_user_id,
        expiration_date: moment().add(1, 'days').format(dbDateFormat),
        schedule_user_id: target?.user?.schedule_user_id,
        type: isReport ? 'reports' : undefined
    }
}

const getUserNoteExportInitialValues = ({target}) => {
    const lang = store.getState().userSettings.lang

    return {
        locale: lang?.language === 'Hebrew' ? 'he' : 'en',
        subject: '',
        message_content: t(`user-note-export-content-default${target?.relation ? '-schedule' : ''}`),
        email_to: target?.users_boxes?.user?.email ?? '',
        note_relation_id: target?.note_relation_id ?? null
    }
}

const getSendConfirmationLinkInitialValues = ({target, initProps}) => {
    const sendConfirmationLinkMessage = store.getState().userSettings.sendConfirmationLinkMessage
    return {
        user_fk: target?.user?.user_fk,
        phone: target?.user?.phone || null,
        email: target?.user?.email || null,
        full_name: target?.user?.full_name || null,
        send_push: false,
        send_sms: true,
        send_email: false,
        send_whatsapp: false,
        subject: '',
        message_content: sendConfirmationLinkMessage || t('default-message-send-confirmation'),
        message_template_id: null,
        schedule_user_id: target?.user?.schedule_user_id
    }
}

const getGroupConnectionAddUserInitialValues = (target) => {
    return {
        newUser: getUserDetailsBaseInitialValues('member'),
        users_boxes_id: null,
        child: 1,
        head: false,
        groups_id: target?.groupData?.[0]?.groups_id || null,
        groups_ub_ids: target?.groupData?.[0] ? target?.groupData?.map(member => member?.users_boxes_id) : [target?.user?.id]
    }
}

const getEditMultiDaysValidationSchema = () => {
    const flowName = store.getState().stepper.name
    const editType = store.getState().stepper.editType

    switch (flowName) {
        case flowOptions.WORKSHOP_FLOW:
            return getWorkshopSeriesDaysEditValidationSchema().shape({
                date: yup.string().required(t('thisFieldIsMandatory')).test('date-format', 'invalid date', function(value){
                    return moment(value, dbDateFormat).format(dbDateFormat) === value
                })
            })
        case flowOptions.AVAILABILITY:
            return getEditAvailabilityBasicValidationSchema().shape({
                coach_ub_id: yup.number().positive().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
            })
        case flowOptions.SPACE_AVAILABILITY:
            return getEditAvailabilityBasicValidationSchema().shape({
                spaces_id: yup.number().positive().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
            })
        case flowOptions.HUGIM_FLOW:
            if(editType === SERIES_FUTURE_SESSIONS_EDIT_TYPE) {
                return getWorkshopSeriesDaysEditValidationSchema().shape({
                    isUnlimited: yup.boolean(),
                    isOneDay: yup.boolean(),
                    date: yup.string().required(t('thisFieldIsMandatory')).test('date-format', 'invalid date', function(value){
                        return moment(value, dbDateFormat).format(dbDateFormat) === value
                    }),
                    start_date: yup.string().required(t('thisFieldIsMandatory')).test('date-format', 'invalid date', function(value){
                        return moment(value, dbDateFormat).format(dbDateFormat) === value
                    }),
                    end_date: yup.string().when("isUnlimited", {
                        is: true,
                        then: yup.string().nullable(true).test('is-null', 'end_date must be null', value => value === null), //must be null when isUnlimited=true
                        otherwise: yup.string().required(t('thisFieldIsMandatory')).when(['start_date', 'isOneDay'], (start_date, isOneDay, schema) => {
                            const start = moment(start_date, dbDateFormat)
                            return schema.test({
                                test: end => end && (isOneDay ? moment(end, dbDateFormat).isSame(start) : moment(end, dbDateFormat).isAfter(start)),
                                message: t('shiftTimeError')
                            })
                        }).test('date-format', 'invalid date', function(value){
                            return value && (moment(value, dbDateFormat).format(dbDateFormat) === value)
                        }),
                    })
                })
            } else {
                return yup.object().shape({
                    date: yup.string().required(t('thisFieldIsMandatory')).test('date-format', 'invalid date', function(value){
                        return moment(value, dbDateFormat).format(dbDateFormat) === value
                    }),
                    start_time: yup.string().required(t('thisFieldIsMandatory')).test('time-format', 'invalid time', function (value) {
                        return moment(value, dbTimeFormat).format(dbTimeFormat) === value
                    }),
                    end_time: yup.string().required(t('thisFieldIsMandatory')).when(['start_time'], (start_time, schema) => {
                        const start = moment(start_time, dbTimeFormat)
                        return schema.test({
                            test: end => moment(end, dbTimeFormat).isAfter(start),
                            message: t('shiftTimeError')
                        })
                    }).test('time-format', 'invalid time', function (value) {
                        console.log(' end time',value, moment(value, dbTimeFormat).format(dbTimeFormat))
                        return moment(value, dbTimeFormat).format(dbTimeFormat) === value
                    }),
                })
            }
        default:
            return yup.object().shape({})
    }
}

const getWorkshopSeriesDaysEditValidationSchema = () => {
    return yup.object().shape({
        days: yup.array().of(yup.object().shape({
            start_time: yup.string().required(t('thisFieldIsMandatory')).test('time-format', 'invalid time', function (value) {
                return moment(value, dbTimeFormat).format(dbTimeFormat) === value
            }),
            end_time: yup.string().required(t('thisFieldIsMandatory')).when(['start_time'], (start_time, schema) => {
                const start = moment(start_time, dbTimeFormat)
                return schema.test({
                    test: end => moment(end, dbTimeFormat).isAfter(start),
                    message: t('shiftTimeError')
                })
            }).test('time-format', 'invalid time', function (value) {
                return moment(value, dbTimeFormat).format(dbTimeFormat) === value
            }),
            day_of_week: yup.number().min(0).max(6).required(t('thisFieldIsMandatory')),
            description: yup.string().min(2, t('nameErrorMsg')).max(20, t('nameErrorMsg')).nullable()
        }))
    })
}

const getSpaceConfigValidationSchema = () => {
    return yup.object().shape({
        locations_box_id: yup.number().positive().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        name: yup.string().required(t('thisFieldIsMandatory')).min(2, t('nameErrorMsg')).max(20, t('nameErrorMsg')),
        availabilityInfo: getAvailabilityBasicValidationSchema().nullable()
    })
}

const getAvailabilityBasicValidationSchema = () => {
    return yup.object().shape({
        date: yup.string().required(t('thisFieldIsMandatory')).test('date-format', 'invalid date', function (value) {
            return moment(value, dbDateFormat).format(dbDateFormat) === value
        }),
        repeat: yup.boolean().required(),
        slot_length: yup.number().min(1,`${t('largerThanErrorMsg')}1`).required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        break_length: yup.number().min(0,`${t('largerThanErrorMsg')}0`).required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        block_registration_time: yup.number().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        multiDayConfig: yup.array().of(yup.object().shape({
            day: yup.number().min(0).max(6).required(t('thisFieldIsMandatory')),
            setting: yup.array().of(yup.object().shape({
                start_time: yup.string().required(t('thisFieldIsMandatory')).test('time-format', 'invalid time', function (value) {
                    return moment(value, dbTimeFormat).format(dbTimeFormat) === value
                }),
                end_time: yup.string().required(t('thisFieldIsMandatory')).when(['start_time'], (start_time, schema) => {
                    const start = moment(start_time, dbTimeFormat)
                    return schema.test({
                        test: end => moment(end, dbTimeFormat).isAfter(start),
                        message: t('shiftTimeError')
                    })
                }).test('time-format', 'invalid time', function (value) {
                    return moment(value, dbTimeFormat).format(dbTimeFormat) === value
                }),
                limitations: yup.array().ensure()
            }))
        })).min(1, t('one-day-minimum')),
    })
}

const getEditAvailabilityBasicValidationSchema = () => {
    return yup.object().shape({
        date: yup.string().required(t('thisFieldIsMandatory')).test('date-format', 'invalid date', function(value){
            return moment(value, dbDateFormat).format(dbDateFormat) === value
        }),
        location_fk: yup.number().positive().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        slot_length: yup.number().positive().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        break_length: yup.number().min(0,`${t('largerThanErrorMsg')}0`).required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        block_registration_time: yup.number().required(t('thisFieldIsMandatory')).typeError(t('thisFieldIsMandatory')),
        start_time: yup.string().required(t('thisFieldIsMandatory')).test('time-format', 'invalid time', function (value) {
            return moment(value, dbTimeFormat).format(dbTimeFormat) === value
        }),
        end_time: yup.string().required(t('thisFieldIsMandatory')).when(['start_time'], (start_time, schema) => {
            const start = moment(start_time, dbTimeFormat)
            return schema.test({
                test: end => moment(end, dbTimeFormat).isAfter(start),
                message: t('shiftTimeError')
            })
        }).test('time-format', 'invalid time', function (value) {
            return moment(value, dbTimeFormat).format(dbTimeFormat) === value
        }),
        day_of_week: yup.number().min(0).max(6).required(t('thisFieldIsMandatory')),
        limitations: yup.array().ensure()
    })
}

const getPenaltiesSettingsValidationSchema = () => {
    const target = store.getState().stepper.props.target;
    const all = store.getState().stepper.props.all?.filter(p => p.id !== target?.id)?.map(p => p.name);
    const getYupByType = (type) => {
        return yup.number().when('type', {
            is: value => value === type,
            then: yup.number().min(1).required(t('thisFieldIsMandatory'))
        })
    }
    return yup.object().shape({
        name: yup.string().required(t('thisFieldIsMandatory')).test('name-unique', t('name-must-be-unique'), function (val) {
            return !all.includes(val);
        }),
        start_date: yup.string().required().test('start_date', t('start-date-must-be-a-future-date'), function (val) {
            if (target && target.start_date < moment().format(dbDateFormat)) {
                return true;
            }
            return val >= moment().format(dbDateFormat)
        }),
        trigger_occurrence_count: yup.number().min(1).required(t('thisFieldIsMandatory')),
        trigger_period_count: yup.number().min(1).required(t('thisFieldIsMandatory')),
        late_cancellation: yup.boolean().test('late_cancellation', t('select-at-least-1'), function(value){
            return this.parent.check_in || value
        }),
        check_in: yup.boolean().test('check_in', t('select-at-least-1'), function(value){
            return this.parent.late_cancellation || value
        }),
        type: yup.string().oneOf(['reduction', 'block_app_cancel', 'block_app_no_cancel', 'block_book_cancel', 'block_book_no_cancel', 'no_block_cancel']).required(),
        reduction: getYupByType('reduction'),
        block_app_cancel: getYupByType('block_app_cancel'),
        block_app_no_cancel: getYupByType('block_app_no_cancel'),
        block_book_cancel: getYupByType('block_book_cancel'),
        block_book_no_cancel: getYupByType('block_book_no_cancel'),
        no_block_cancel: getYupByType('no_block_cancel'),
        time_after_class: yup.number().oneOf([1,2,3,4]).required()
    }).concat(target ? getExtraPenaltiesPropertiesValidationSchema() : yup.object().shape({}));
}

const getExtraPenaltiesPropertiesValidationSchema = () => {
    return yup.object().shape({
        membership_types: yup.array(yup.object().shape({
            id: yup.number().required()
        })).min(1, t('select-at-least-1-plan-or-session-pack')),
        available_in_app: yup.boolean(),
        item_id: null,
        send_push: yup.boolean(),
        send_email: yup.boolean(),
        send_sms: yup.boolean(),
        send_whatsapp: yup.boolean(),
        message_content: yup.string().required(t('thisFieldIsMandatory')),
        free_space: yup.number(t('onlyWhole')).integer(t('onlyWhole')).min(0, t('onlyPositive')).typeError(t('onlyWhole')),
        properties: yup.object().shape({
            exclude: yup.array(yup.object().shape({
                box_categories: yup.array(yup.number())
            })).nullable()
        }).nullable()
    })
}

const getSendConvertLinkValidationSchema = () => {
    return yup.object().shape({
        user_fk: yup.number().when('type', {
            is: undefined,
            then: yup.number().required(t('thisFieldIsMandatory')).test('user_has_phone_email', t('user-must-have-a-phone-number-and-email'), function (value) {
                return (this.parent.send_whatsapp || this.parent.send_sms) && this.parent.send_email ? this.parent.phone && this.parent.email : true
            }).test('user_has_phone', t('user-must-have-a-phone-number'), function (value) {
                return (this.parent.send_whatsapp || this.parent.send_sms) ? this.parent.phone : true
            }).test('user_has_email', t('user-must-have-an-email'), function (value) {
                return (this.parent.send_email) ? this.parent.email : true
            }),
            otherwise: yup.number().nullable()
        }),
        send_email: yup.boolean(),
        send_sms: yup.boolean().test('send_sms', t('select-at-least-1'), function(value){
            return this.parent.send_email || this.parent.send_whatsapp || value
        }),
        send_whatsapp: yup.boolean(),
        subject: yup.string().when('send_email', {
            is: true,
            then: yup.string().required(t('thisFieldIsMandatory'))
        }),
        message_content: yup.string().required(t('thisFieldIsMandatory'))
        .test('link-required', t('link-is-required'), function (value) {
            return this.parent.message_content?.includes(`[${t('link-to-convert')}]`)
        }),
    })
}

const getBasicWorkshopValidationSchema = () => {
    return yup.object().shape({
        start_date: yup.string().required(t('thisFieldIsMandatory')).test('date-format', 'invalid date', function(value){
            return moment(value, dbDateFormat).format(dbDateFormat) === value
        }),
        multiDayConfig: yup.object().shape({
            days: yup.array().of(yup.object().shape({
                day: yup.number().min(0).max(6),
                start_time: yup.string().required(t('thisFieldIsMandatory')).test('time-format', 'invalid time', function (value) {
                    return moment(value, dbTimeFormat).format(dbTimeFormat) === value
                }),
                end_time: yup.string().required(t('thisFieldIsMandatory')).when(['start_time'], (start_time, schema) => {
                    const start = moment(start_time, dbTimeFormat)
                    return schema.test({
                        test: end => moment(end, dbTimeFormat).isAfter(start),
                        message: t('shiftTimeError')
                    })
                }).test('time-format', 'invalid time', function (value) {
                    return moment(value, dbTimeFormat).format(dbTimeFormat) === value
                }),
                description: yup.string().min(2, t('nameErrorMsg')).max(20, t('nameErrorMsg')).nullable()
            })).min(1, t('one-day-minimum')),
            seriesName: yup.string().nullable()
        })
    })
}